"use strict";
/**
 * This file was auto-generated by openapi-typescript.
 * Do not make direct changes to the file.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.mockPutDocumentUploadSuccess = exports.fetchPutDocumentUpload = exports.mockPostDocumentUploadFailure = exports.mockPostDocumentUploadSuccess = exports.fetchPostDocumentUpload = exports.mockGetDocumentUploadFailure = exports.mockGetDocumentUploadSuccess = exports.fetchGetDocumentUpload = exports.mockGetCreditFacilityStatusFailure = exports.mockGetCreditFacilityStatusSuccess = exports.fetchGetCreditFacilityStatus = exports.mockGetCbilsEligibilitySelfAssessmentFailure = exports.mockGetCbilsEligibilitySelfAssessmentSuccess = exports.fetchGetCbilsEligibilitySelfAssessment = exports.mockGetAuthenticationCheckFailure = exports.mockGetAuthenticationCheckSuccess = exports.fetchGetAuthenticationCheck = exports.mockGetApplicationsOffersFailure = exports.mockGetApplicationsOffersSuccess = exports.fetchGetApplicationsOffers = exports.mockPostApplicationRefreshFailure = exports.mockPostApplicationRefreshSuccess = exports.fetchPostApplicationRefresh = exports.mockPostApplicationDeferFailure = exports.mockPostApplicationDeferSuccess = exports.fetchPostApplicationDefer = exports.mockPostApplicationDeclineFailure = exports.mockPostApplicationDeclineSuccess = exports.fetchPostApplicationDecline = exports.mockPutApplicationFailure = exports.mockPutApplicationSuccess = exports.fetchPutApplication = exports.mockPostApplicationFailure = exports.mockPostApplicationSuccess = exports.fetchPostApplication = exports.mockGetApplicationFailure = exports.mockGetApplicationSuccess = exports.fetchGetApplication = exports.mockPostAnonymisedDataEvaluationFailure = exports.mockPostAnonymisedDataEvaluationSuccess = exports.fetchPostAnonymisedDataEvaluation = exports.mockGetAdvertisedProductsFailure = exports.mockGetAdvertisedProductsSuccess = exports.fetchGetAdvertisedProducts = exports.mockGetAccountsFailure = exports.mockGetAccountsSuccess = exports.fetchGetAccounts = exports.mockLendingApi = exports.fetchLendingAPIJSON = exports.fetchLendingAPI = void 0;
exports.fetchGetFormalOffersFlexi24Configuration = exports.mockPutFormalOffersCreditFacilityConfigurationFailure = exports.mockPutFormalOffersCreditFacilityConfigurationSuccess = exports.fetchPutFormalOffersCreditFacilityConfiguration = exports.mockGetFormalOffersCreditFacilityConfigurationFailure = exports.mockGetFormalOffersCreditFacilityConfigurationSuccess = exports.fetchGetFormalOffersCreditFacilityConfiguration = exports.mockPutFormalOffersCbilsConfigurationFailure = exports.mockPutFormalOffersCbilsConfigurationSuccess = exports.fetchPutFormalOffersCbilsConfiguration = exports.mockGetFormalOffersCbilsConfigurationFailure = exports.mockGetFormalOffersCbilsConfigurationSuccess = exports.fetchGetFormalOffersCbilsConfiguration = exports.mockPutFormalOffersBusinessLoanConfigurationFailure = exports.mockPutFormalOffersBusinessLoanConfigurationSuccess = exports.fetchPutFormalOffersBusinessLoanConfiguration = exports.mockGetFormalOffersBusinessLoanConfigurationFailure = exports.mockGetFormalOffersBusinessLoanConfigurationSuccess = exports.fetchGetFormalOffersBusinessLoanConfiguration = exports.mockPostFormalOffersFailure = exports.mockPostFormalOffersSuccess = exports.fetchPostFormalOffers = exports.mockGetFormalOffersFailure = exports.mockGetFormalOffersSuccess = exports.fetchGetFormalOffers = exports.mockPostFormalIndicativeOffersFailure = exports.mockPostFormalIndicativeOffersSuccess = exports.fetchPostFormalIndicativeOffers = exports.mockGetFormalIndicativeOffersFailure = exports.mockGetFormalIndicativeOffersSuccess = exports.fetchGetFormalIndicativeOffers = exports.mockGetExampleRepaymentScheduleSummariesFailure = exports.mockGetExampleRepaymentScheduleSummariesSuccess = exports.fetchGetExampleRepaymentScheduleSummaries = exports.mockGetExampleRepaymentScheduleFailure = exports.mockGetExampleRepaymentScheduleSuccess = exports.fetchGetExampleRepaymentSchedule = exports.mockPostEcommerceSellerOrderFailure = exports.mockPostEcommerceSellerOrderSuccess = exports.fetchPostEcommerceSellerOrder = exports.mockGetEcommerceOrderFailure = exports.mockGetEcommerceOrderSuccess = exports.fetchGetEcommerceOrder = exports.mockGetEarlyRepaymentSimulationFailure = exports.mockGetEarlyRepaymentSimulationSuccess = exports.fetchGetEarlyRepaymentSimulation = exports.mockGetDrawDownRepaymentScheduleIwocapayFailure = exports.mockGetDrawDownRepaymentScheduleIwocapaySuccess = exports.fetchGetDrawDownRepaymentScheduleIwocapay = exports.mockPutDocumentUploadFailure = void 0;
exports.mockGetFundingRequirementsBusinessLoanFailure = exports.mockGetFundingRequirementsBusinessLoanSuccess = exports.fetchGetFundingRequirementsBusinessLoan = exports.mockPostFundingRequestRecoveryLoanFailure = exports.mockPostFundingRequestRecoveryLoanSuccess = exports.fetchPostFundingRequestRecoveryLoan = exports.mockPostFundingRequestMerchantCashAdvanceFailure = exports.mockPostFundingRequestMerchantCashAdvanceSuccess = exports.fetchPostFundingRequestMerchantCashAdvance = exports.mockPostFundingRequestIwocapayFailure = exports.mockPostFundingRequestIwocapaySuccess = exports.fetchPostFundingRequestIwocapay = exports.mockPostFundingRequestFlexi24Failure = exports.mockPostFundingRequestFlexi24Success = exports.fetchPostFundingRequestFlexi24 = exports.mockPostFundingRequestCreditFacilityFailure = exports.mockPostFundingRequestCreditFacilitySuccess = exports.fetchPostFundingRequestCreditFacility = exports.mockPostFundingRequestCbilsFailure = exports.mockPostFundingRequestCbilsSuccess = exports.fetchPostFundingRequestCbils = exports.mockPostFundingRequestBusinessLoanFailure = exports.mockPostFundingRequestBusinessLoanSuccess = exports.fetchPostFundingRequestBusinessLoan = exports.mockPostFundSellerRequestFailure = exports.mockPostFundSellerRequestSuccess = exports.fetchPostFundSellerRequest = exports.mockPutFormalOffersRecoveryLoanConfigurationFailure = exports.mockPutFormalOffersRecoveryLoanConfigurationSuccess = exports.fetchPutFormalOffersRecoveryLoanConfiguration = exports.mockGetFormalOffersRecoveryLoanConfigurationFailure = exports.mockGetFormalOffersRecoveryLoanConfigurationSuccess = exports.fetchGetFormalOffersRecoveryLoanConfiguration = exports.mockPutFormalOffersMerchantCashAdvanceConfigurationFailure = exports.mockPutFormalOffersMerchantCashAdvanceConfigurationSuccess = exports.fetchPutFormalOffersMerchantCashAdvanceConfiguration = exports.mockGetFormalOffersMerchantCashAdvanceConfigurationFailure = exports.mockGetFormalOffersMerchantCashAdvanceConfigurationSuccess = exports.fetchGetFormalOffersMerchantCashAdvanceConfiguration = exports.mockPutFormalOffersIwocapayConfigurationFailure = exports.mockPutFormalOffersIwocapayConfigurationSuccess = exports.fetchPutFormalOffersIwocapayConfiguration = exports.mockGetFormalOffersIwocapayConfigurationFailure = exports.mockGetFormalOffersIwocapayConfigurationSuccess = exports.fetchGetFormalOffersIwocapayConfiguration = exports.mockPutFormalOffersFlexi24ConfigurationFailure = exports.mockPutFormalOffersFlexi24ConfigurationSuccess = exports.fetchPutFormalOffersFlexi24Configuration = exports.mockGetFormalOffersFlexi24ConfigurationFailure = exports.mockGetFormalOffersFlexi24ConfigurationSuccess = void 0;
exports.mockPostIntroducerLinkOpenBankingEmailSuccess = exports.fetchPostIntroducerLinkOpenBankingEmail = exports.mockGetIntroducerContextFailure = exports.mockGetIntroducerContextSuccess = exports.fetchGetIntroducerContext = exports.mockGetIntroducerContextByIntroducerIdFailure = exports.mockGetIntroducerContextByIntroducerIdSuccess = exports.fetchGetIntroducerContextByIntroducerId = exports.mockGetIntroducerApplicationsFailure = exports.mockGetIntroducerApplicationsSuccess = exports.fetchGetIntroducerApplications = exports.mockGetIntroducerApplicationRejectOfferReasonsFailure = exports.mockGetIntroducerApplicationRejectOfferReasonsSuccess = exports.fetchGetIntroducerApplicationRejectOfferReasons = exports.mockPutIntroducerApplicationOfferWithdrawalFeeRateFailure = exports.mockPutIntroducerApplicationOfferWithdrawalFeeRateSuccess = exports.fetchPutIntroducerApplicationOfferWithdrawalFeeRate = exports.mockGetIntroducerApplicationOfferWithdrawalFeeRateFailure = exports.mockGetIntroducerApplicationOfferWithdrawalFeeRateSuccess = exports.fetchGetIntroducerApplicationOfferWithdrawalFeeRate = exports.mockGetIntroducerApplicationOfferAllowedWithdrawalFeeRatesFailure = exports.mockGetIntroducerApplicationOfferAllowedWithdrawalFeeRatesSuccess = exports.fetchGetIntroducerApplicationOfferAllowedWithdrawalFeeRates = exports.mockGetIntroducerApplicationFailure = exports.mockGetIntroducerApplicationSuccess = exports.fetchGetIntroducerApplication = exports.mockGetIntroducerFailure = exports.mockGetIntroducerSuccess = exports.fetchGetIntroducer = exports.mockPostIntroducerFailure = exports.mockPostIntroducerSuccess = exports.fetchPostIntroducer = exports.mockGetFundingRequirementsRecoveryLoanFailure = exports.mockGetFundingRequirementsRecoveryLoanSuccess = exports.fetchGetFundingRequirementsRecoveryLoan = exports.mockGetFundingRequirementsMerchantCashAdvanceFailure = exports.mockGetFundingRequirementsMerchantCashAdvanceSuccess = exports.fetchGetFundingRequirementsMerchantCashAdvance = exports.mockGetFundingRequirementsIwocapayFailure = exports.mockGetFundingRequirementsIwocapaySuccess = exports.fetchGetFundingRequirementsIwocapay = exports.mockGetFundingRequirementsFlexi24Failure = exports.mockGetFundingRequirementsFlexi24Success = exports.fetchGetFundingRequirementsFlexi24 = exports.mockGetFundingRequirementsCreditFacilityFailure = exports.mockGetFundingRequirementsCreditFacilitySuccess = exports.fetchGetFundingRequirementsCreditFacility = exports.mockGetFundingRequirementsCbilsFailure = exports.mockGetFundingRequirementsCbilsSuccess = exports.fetchGetFundingRequirementsCbils = void 0;
exports.fetchGetLoanDocumentsRequiredFlexi24 = exports.mockGetLoanDocumentsRequiredCreditFacilityFailure = exports.mockGetLoanDocumentsRequiredCreditFacilitySuccess = exports.fetchGetLoanDocumentsRequiredCreditFacility = exports.mockGetLoanDocumentsRequiredCbilsFailure = exports.mockGetLoanDocumentsRequiredCbilsSuccess = exports.fetchGetLoanDocumentsRequiredCbils = exports.mockGetLoanDocumentsRequiredBusinessLoanFailure = exports.mockGetLoanDocumentsRequiredBusinessLoanSuccess = exports.fetchGetLoanDocumentsRequiredBusinessLoan = exports.mockPostIwocapaySellerOnboardingAnswersFailure = exports.mockPostIwocapaySellerOnboardingAnswersSuccess = exports.fetchPostIwocapaySellerOnboardingAnswers = exports.mockGetIwocapaySellerOnboardingAnswersFailure = exports.mockGetIwocapaySellerOnboardingAnswersSuccess = exports.fetchGetIwocapaySellerOnboardingAnswers = exports.mockGetIwocapayReferrerFailure = exports.mockGetIwocapayReferrerSuccess = exports.fetchGetIwocapayReferrer = exports.mockGetIwocapayReferralsFailure = exports.mockGetIwocapayReferralsSuccess = exports.fetchGetIwocapayReferrals = exports.mockGetIwocapayReferralFailure = exports.mockGetIwocapayReferralSuccess = exports.fetchGetIwocapayReferral = exports.mockPostIwocapayPaymentNowFailure = exports.mockPostIwocapayPaymentNowSuccess = exports.fetchPostIwocapayPaymentNow = exports.mockPostIwocapayPaymentLaterFailure = exports.mockPostIwocapayPaymentLaterSuccess = exports.fetchPostIwocapayPaymentLater = exports.mockGetIwocapayPaymentLaterFailure = exports.mockGetIwocapayPaymentLaterSuccess = exports.fetchGetIwocapayPaymentLater = exports.mockPostIwocapayPayLinkPackageFailure = exports.mockPostIwocapayPayLinkPackageSuccess = exports.fetchPostIwocapayPayLinkPackage = exports.mockGetIwocapayPayLinkPackageFailure = exports.mockGetIwocapayPayLinkPackageSuccess = exports.fetchGetIwocapayPayLinkPackage = exports.mockPostIwocapayNotificationsFailure = exports.mockPostIwocapayNotificationsSuccess = exports.fetchPostIwocapayNotifications = exports.mockGetIwocapayBuyerPayLinkPackageFailure = exports.mockGetIwocapayBuyerPayLinkPackageSuccess = exports.fetchGetIwocapayBuyerPayLinkPackage = exports.mockPutIntroducerUpdateFormalOfferEntityToContactFailure = exports.mockPutIntroducerUpdateFormalOfferEntityToContactSuccess = exports.fetchPutIntroducerUpdateFormalOfferEntityToContact = exports.mockPostIntroducerLinkOpenBankingEmailFailure = void 0;
exports.mockPostOutstandingCbilsOrBblFailure = exports.mockPostOutstandingCbilsOrBblSuccess = exports.fetchPostOutstandingCbilsOrBbl = exports.mockGetOutstandingCbilsOrBblFailure = exports.mockGetOutstandingCbilsOrBblSuccess = exports.fetchGetOutstandingCbilsOrBbl = exports.mockGetOnlineAccountFailure = exports.mockGetOnlineAccountSuccess = exports.fetchGetOnlineAccount = exports.mockPostOnfidoTokenFailure = exports.mockPostOnfidoTokenSuccess = exports.fetchPostOnfidoToken = exports.mockPostOnfidoStartFailure = exports.mockPostOnfidoStartSuccess = exports.fetchPostOnfidoStart = exports.mockPostOnfidoChecksFailure = exports.mockPostOnfidoChecksSuccess = exports.fetchPostOnfidoChecks = exports.mockGetOnfidoCheckFailure = exports.mockGetOnfidoCheckSuccess = exports.fetchGetOnfidoCheck = exports.mockGetMcaEstimatedScheduleFailure = exports.mockGetMcaEstimatedScheduleSuccess = exports.fetchGetMcaEstimatedSchedule = exports.mockPostLogoutFailure = exports.mockPostLogoutSuccess = exports.fetchPostLogout = exports.mockGetLoginLinkFailure = exports.mockGetLoginLinkSuccess = exports.fetchGetLoginLink = exports.mockGetLoanDocumentsUnsignedFailure = exports.mockGetLoanDocumentsUnsignedSuccess = exports.fetchGetLoanDocumentsUnsigned = exports.mockGetLoanDocumentsSignedFailure = exports.mockGetLoanDocumentsSignedSuccess = exports.fetchGetLoanDocumentsSigned = exports.mockPostLoanDocumentsSignedFailure = exports.mockPostLoanDocumentsSignedSuccess = exports.fetchPostLoanDocumentsSigned = exports.mockGetLoanDocumentsRequiredRecoveryLoanFailure = exports.mockGetLoanDocumentsRequiredRecoveryLoanSuccess = exports.fetchGetLoanDocumentsRequiredRecoveryLoan = exports.mockGetLoanDocumentsRequiredMerchantCashAdvanceFailure = exports.mockGetLoanDocumentsRequiredMerchantCashAdvanceSuccess = exports.fetchGetLoanDocumentsRequiredMerchantCashAdvance = exports.mockGetLoanDocumentsRequiredIwocapayFailure = exports.mockGetLoanDocumentsRequiredIwocapaySuccess = exports.fetchGetLoanDocumentsRequiredIwocapay = exports.mockGetLoanDocumentsRequiredFlexi24Failure = exports.mockGetLoanDocumentsRequiredFlexi24Success = void 0;
exports.mockPostPledgeCallFailure = exports.mockPostPledgeCallSuccess = exports.fetchPostPledgeCall = exports.mockPostPayLinkApplicationFailure = exports.mockPostPayLinkApplicationSuccess = exports.fetchPostPayLinkApplication = exports.mockGetPayLinkFailure = exports.mockGetPayLinkSuccess = exports.fetchGetPayLink = exports.mockGetPayLinkByPayLinkIdFailure = exports.mockGetPayLinkByPayLinkIdSuccess = exports.fetchGetPayLinkByPayLinkId = exports.mockGetPayLinkGoFailure = exports.fetchGetPayLinkGo = exports.mockPutPayLinkFailure = exports.mockPutPayLinkSuccess = exports.fetchPutPayLink = exports.mockPostPayLinkFailure = exports.mockPostPayLinkSuccess = exports.fetchPostPayLink = exports.mockPostPasswordlessEmailLoginFailure = exports.mockPostPasswordlessEmailLoginSuccess = exports.fetchPostPasswordlessEmailLogin = exports.mockPostPasswordlessEmailFailure = exports.mockPostPasswordlessEmailSuccess = exports.fetchPostPasswordlessEmail = exports.mockPostPasswordResetVerifyFailure = exports.mockPostPasswordResetVerifySuccess = exports.fetchPostPasswordResetVerify = exports.mockPostPasswordResetSetPasswordFailure = exports.mockPostPasswordResetSetPasswordSuccess = exports.fetchPostPasswordResetSetPassword = exports.mockPostPasswordResetFailure = exports.mockPostPasswordResetSuccess = exports.fetchPostPasswordReset = exports.mockPostPasswordLoginFailure = exports.mockPostPasswordLoginSuccess = exports.fetchPostPasswordLogin = exports.mockPostPartnerDeveloperFailure = exports.mockPostPartnerDeveloperSuccess = exports.fetchPostPartnerDeveloper = exports.mockGetPartnerBrokersFailure = exports.mockGetPartnerBrokersSuccess = exports.fetchGetPartnerBrokers = exports.mockPutOutstandingGovernmentSchemeLoansFailure = exports.mockPutOutstandingGovernmentSchemeLoansSuccess = exports.fetchPutOutstandingGovernmentSchemeLoans = exports.mockGetOutstandingGovernmentSchemeLoansFailure = exports.mockGetOutstandingGovernmentSchemeLoansSuccess = exports.fetchGetOutstandingGovernmentSchemeLoans = void 0;
exports.mockGetSellerAgreementDocumentDownloadSuccess = exports.fetchGetSellerAgreementDocumentDownload = exports.mockGetSellerAgreementDocumentFailure = exports.mockGetSellerAgreementDocumentSuccess = exports.fetchGetSellerAgreementDocument = exports.mockPutSellerPricingFailure = exports.mockPutSellerPricingSuccess = exports.fetchPutSellerPricing = exports.mockGetSellerPricingFailure = exports.mockGetSellerPricingSuccess = exports.fetchGetSellerPricing = exports.mockPostSellerHandleFailure = exports.mockPostSellerHandleSuccess = exports.fetchPostSellerHandle = exports.mockPostSellerFailure = exports.mockPostSellerSuccess = exports.fetchPostSeller = exports.mockGetSellerFailure = exports.mockGetSellerSuccess = exports.fetchGetSeller = exports.mockGetSellerHandleAvailabilityFailure = exports.mockGetSellerHandleAvailabilitySuccess = exports.fetchGetSellerHandleAvailability = exports.mockGetSellerHandleFailure = exports.mockGetSellerHandleSuccess = exports.fetchGetSellerHandle = exports.mockPutRlsEligibilitySelfAssessmentFailure = exports.mockPutRlsEligibilitySelfAssessmentSuccess = exports.fetchPutRlsEligibilitySelfAssessment = exports.mockGetRlsEligibilitySelfAssessmentFailure = exports.mockGetRlsEligibilitySelfAssessmentSuccess = exports.fetchGetRlsEligibilitySelfAssessment = exports.mockPostRequestedAmountFailure = exports.mockPostRequestedAmountSuccess = exports.fetchPostRequestedAmount = exports.mockPostRepaymentPaymentIntentFailure = exports.mockPostRepaymentPaymentIntentSuccess = exports.fetchPostRepaymentPaymentIntent = exports.mockPostRejectOfferReasonsFailure = exports.mockPostRejectOfferReasonsSuccess = exports.fetchPostRejectOfferReasons = exports.mockGetProfileFailure = exports.mockGetProfileSuccess = exports.fetchGetProfile = exports.mockGetProductOffersFailure = exports.mockGetProductOffersSuccess = exports.fetchGetProductOffers = exports.mockGetProductOffersByRestrictedExternalDataSyncsAuthorisationFailure = exports.mockGetProductOffersByRestrictedExternalDataSyncsAuthorisationSuccess = exports.fetchGetProductOffersByRestrictedExternalDataSyncsAuthorisation = void 0;
exports.mockGetXeroConnectionsSuccess = exports.fetchGetXeroConnections = exports.mockPostXeroConnectFailure = exports.mockPostXeroConnectSuccess = exports.fetchPostXeroConnect = exports.mockGetXeroCallbackFailure = exports.fetchGetXeroCallback = exports.mockGetXeroAccountsFailure = exports.mockGetXeroAccountsSuccess = exports.fetchGetXeroAccounts = exports.mockPutThreatmetrixEventFailure = exports.mockPutThreatmetrixEventSuccess = exports.fetchPutThreatmetrixEvent = exports.mockPostThreatmetrixEventFailure = exports.mockPostThreatmetrixEventSuccess = exports.fetchPostThreatmetrixEvent = exports.mockGetStatementsFailure = exports.mockGetStatementsSuccess = exports.fetchGetStatements = exports.mockPutStateFailure = exports.mockPutStateSuccess = exports.fetchPutState = exports.mockGetStateFailure = exports.mockGetStateSuccess = exports.fetchGetState = exports.mockGetStateByStateKeyFailure = exports.mockGetStateByStateKeySuccess = exports.fetchGetStateByStateKey = exports.mockPostStateFailure = exports.mockPostStateSuccess = exports.fetchPostState = exports.mockPostSingleImmediatePaymentSendConfirmationEmailFailure = exports.mockPostSingleImmediatePaymentSendConfirmationEmailSuccess = exports.fetchPostSingleImmediatePaymentSendConfirmationEmail = exports.mockGetSingleImmediatePaymentFailure = exports.mockGetSingleImmediatePaymentSuccess = exports.fetchGetSingleImmediatePayment = exports.mockPostSingleImmediatePaymentProcessWebhookFailure = exports.mockPostSingleImmediatePaymentProcessWebhookSuccess = exports.fetchPostSingleImmediatePaymentProcessWebhook = exports.mockPostSingleImmediatePaymentFailure = exports.mockPostSingleImmediatePaymentSuccess = exports.fetchPostSingleImmediatePayment = exports.mockGetSellerOnboardingRequirementsFailure = exports.mockGetSellerOnboardingRequirementsSuccess = exports.fetchGetSellerOnboardingRequirements = exports.mockPutSellerAgreementDocumentSignFailure = exports.mockPutSellerAgreementDocumentSignSuccess = exports.fetchPutSellerAgreementDocumentSign = exports.mockGetSellerAgreementDocumentDownloadFailure = void 0;
exports.mockPutXeroOrganisationAccountFailure = exports.mockPutXeroOrganisationAccountSuccess = exports.fetchPutXeroOrganisationAccount = exports.mockPostXeroOrganisationAccountFailure = exports.mockPostXeroOrganisationAccountSuccess = exports.fetchPostXeroOrganisationAccount = exports.mockGetXeroOrganisationAccountFailure = exports.mockGetXeroOrganisationAccountSuccess = exports.fetchGetXeroOrganisationAccount = exports.mockPostXeroLoginFailure = exports.mockPostXeroLoginSuccess = exports.fetchPostXeroLogin = exports.mockGetXeroLoginFailure = exports.fetchGetXeroLogin = exports.mockPostXeroIwocapaySellerBrandingThemesPaymentServicesFailure = exports.mockPostXeroIwocapaySellerBrandingThemesPaymentServicesSuccess = exports.fetchPostXeroIwocapaySellerBrandingThemesPaymentServices = exports.mockGetXeroIwocapaySellerBrandingThemesFailure = exports.mockGetXeroIwocapaySellerBrandingThemesSuccess = exports.fetchGetXeroIwocapaySellerBrandingThemes = exports.mockPutXeroIwocapaySellerAccountFailure = exports.mockPutXeroIwocapaySellerAccountSuccess = exports.fetchPutXeroIwocapaySellerAccount = exports.mockPostXeroIwocapaySellerAccountFailure = exports.mockPostXeroIwocapaySellerAccountSuccess = exports.fetchPostXeroIwocapaySellerAccount = exports.mockGetXeroIwocapaySellerAccountFailure = exports.mockGetXeroIwocapaySellerAccountSuccess = exports.fetchGetXeroIwocapaySellerAccount = exports.mockGetXeroConnectionsFailure = void 0;
const lendingAPI_1 = require("./lendingAPI");
const lendingAPIMock_1 = require("./lendingAPIMock");
var lendingAPI_2 = require("./lendingAPI");
Object.defineProperty(exports, "fetchLendingAPI", { enumerable: true, get: function () { return lendingAPI_2.fetchLendingAPI; } });
Object.defineProperty(exports, "fetchLendingAPIJSON", { enumerable: true, get: function () { return lendingAPI_2.fetchLendingAPIJSON; } });
var lendingAPIMock_2 = require("./lendingAPIMock");
Object.defineProperty(exports, "mockLendingApi", { enumerable: true, get: function () { return lendingAPIMock_2.mockLendingApi; } });
const failureResponse = {
    errors: [
        {
            code: "PermissionDenied",
            detail: "You do not have permission to perform this action.",
        },
    ],
};
/**
 * TBD
 */
function fetchGetAccounts({ stateKey }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/accounts/${stateKey}/`, {
        method: "get",
        version: "edge",
    });
}
exports.fetchGetAccounts = fetchGetAccounts;
function mockGetAccountsSuccess(stateKey, data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/accounts/${stateKey}/`, "get", 200, data, options);
}
exports.mockGetAccountsSuccess = mockGetAccountsSuccess;
function mockGetAccountsFailure(stateKey, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/accounts/${stateKey}/`, "get", 400, failureResponse, options);
}
exports.mockGetAccountsFailure = mockGetAccountsFailure;
/**
 * Get advertised products for a customer
 */
function fetchGetAdvertisedProducts({ stateKey }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/advertised_products/${stateKey}/`, {
        method: "get",
        version: "edge",
    });
}
exports.fetchGetAdvertisedProducts = fetchGetAdvertisedProducts;
function mockGetAdvertisedProductsSuccess(stateKey, data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/advertised_products/${stateKey}/`, "get", 200, data, options);
}
exports.mockGetAdvertisedProductsSuccess = mockGetAdvertisedProductsSuccess;
function mockGetAdvertisedProductsFailure(stateKey, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/advertised_products/${stateKey}/`, "get", 400, failureResponse, options);
}
exports.mockGetAdvertisedProductsFailure = mockGetAdvertisedProductsFailure;
/**
 * Evaluation of anonymised data to determine estimations of approval characteristics.
 */
function fetchPostAnonymisedDataEvaluation({ body, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/anonymised_data_evaluation/`, {
        method: "post",
        version: "edge",
        body,
    });
}
exports.fetchPostAnonymisedDataEvaluation = fetchPostAnonymisedDataEvaluation;
function mockPostAnonymisedDataEvaluationSuccess(data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/anonymised_data_evaluation/`, "post", 201, data, options);
}
exports.mockPostAnonymisedDataEvaluationSuccess = mockPostAnonymisedDataEvaluationSuccess;
function mockPostAnonymisedDataEvaluationFailure(options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/anonymised_data_evaluation/`, "post", 400, failureResponse, options);
}
exports.mockPostAnonymisedDataEvaluationFailure = mockPostAnonymisedDataEvaluationFailure;
/**
 * TBD
 */
function fetchGetApplication({ stateKey }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/application/${stateKey}/`, {
        method: "get",
        version: "edge",
    });
}
exports.fetchGetApplication = fetchGetApplication;
function mockGetApplicationSuccess(stateKey, data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/application/${stateKey}/`, "get", 200, data, options);
}
exports.mockGetApplicationSuccess = mockGetApplicationSuccess;
function mockGetApplicationFailure(stateKey, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/application/${stateKey}/`, "get", 400, failureResponse, options);
}
exports.mockGetApplicationFailure = mockGetApplicationFailure;
/**
 * Create user application. If valid introducer_uuid id is provided, Application will be assigned to him
 */
function fetchPostApplication({ stateKey, body, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/application/${stateKey}/`, {
        method: "post",
        version: "edge",
        body,
    });
}
exports.fetchPostApplication = fetchPostApplication;
function mockPostApplicationSuccess(stateKey, data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/application/${stateKey}/`, "post", 201, data, options);
}
exports.mockPostApplicationSuccess = mockPostApplicationSuccess;
function mockPostApplicationFailure(stateKey, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/application/${stateKey}/`, "post", 400, failureResponse, options);
}
exports.mockPostApplicationFailure = mockPostApplicationFailure;
/**
 * Update user application. If valid introducer_uuid id is provided, Application will be assigned to him
 */
function fetchPutApplication({ stateKey, body, }) {
    return (0, lendingAPI_1.fetchLendingAPI)(`/application/${stateKey}/`, {
        method: "put",
        version: "edge",
        body,
    });
}
exports.fetchPutApplication = fetchPutApplication;
function mockPutApplicationSuccess(stateKey, data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/application/${stateKey}/`, "put", 202, data, options);
}
exports.mockPutApplicationSuccess = mockPutApplicationSuccess;
function mockPutApplicationFailure(stateKey, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/application/${stateKey}/`, "put", 400, failureResponse, options);
}
exports.mockPutApplicationFailure = mockPutApplicationFailure;
/**
 * TBD
 */
function fetchPostApplicationDecline({ stateKey, body, }) {
    return (0, lendingAPI_1.fetchLendingAPI)(`/application/${stateKey}/decline/`, {
        method: "post",
        version: "edge",
        body,
    });
}
exports.fetchPostApplicationDecline = fetchPostApplicationDecline;
function mockPostApplicationDeclineSuccess(stateKey, data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/application/${stateKey}/decline/`, "post", 201, data, options);
}
exports.mockPostApplicationDeclineSuccess = mockPostApplicationDeclineSuccess;
function mockPostApplicationDeclineFailure(stateKey, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/application/${stateKey}/decline/`, "post", 400, failureResponse, options);
}
exports.mockPostApplicationDeclineFailure = mockPostApplicationDeclineFailure;
/**
 * TBD
 */
function fetchPostApplicationDefer({ stateKey, body, }) {
    return (0, lendingAPI_1.fetchLendingAPI)(`/application/${stateKey}/defer/`, {
        method: "post",
        version: "edge",
        body,
    });
}
exports.fetchPostApplicationDefer = fetchPostApplicationDefer;
function mockPostApplicationDeferSuccess(stateKey, data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/application/${stateKey}/defer/`, "post", 201, data, options);
}
exports.mockPostApplicationDeferSuccess = mockPostApplicationDeferSuccess;
function mockPostApplicationDeferFailure(stateKey, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/application/${stateKey}/defer/`, "post", 400, failureResponse, options);
}
exports.mockPostApplicationDeferFailure = mockPostApplicationDeferFailure;
/**
 * Create refreshed application and immediately formalise any appropriate offers
 */
function fetchPostApplicationRefresh({ stateKey, body, }) {
    return (0, lendingAPI_1.fetchLendingAPI)(`/application/${stateKey}/refresh/`, {
        method: "post",
        version: "edge",
        body,
    });
}
exports.fetchPostApplicationRefresh = fetchPostApplicationRefresh;
function mockPostApplicationRefreshSuccess(stateKey, data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/application/${stateKey}/refresh/`, "post", 201, data, options);
}
exports.mockPostApplicationRefreshSuccess = mockPostApplicationRefreshSuccess;
function mockPostApplicationRefreshFailure(stateKey, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/application/${stateKey}/refresh/`, "post", 400, failureResponse, options);
}
exports.mockPostApplicationRefreshFailure = mockPostApplicationRefreshFailure;
/**
 * No description
 */
function fetchGetApplicationsOffers({ applicationId, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/applications/${applicationId}/offers/`, {
        method: "get",
        version: "edge",
    });
}
exports.fetchGetApplicationsOffers = fetchGetApplicationsOffers;
function mockGetApplicationsOffersSuccess(applicationId, data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/applications/${applicationId}/offers/`, "get", 200, data, options);
}
exports.mockGetApplicationsOffersSuccess = mockGetApplicationsOffersSuccess;
function mockGetApplicationsOffersFailure(applicationId, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/applications/${applicationId}/offers/`, "get", 400, failureResponse, options);
}
exports.mockGetApplicationsOffersFailure = mockGetApplicationsOffersFailure;
/**
 * No description
 */
function fetchGetAuthenticationCheck({}) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/authentication_check/`, {
        method: "get",
        version: "edge",
    });
}
exports.fetchGetAuthenticationCheck = fetchGetAuthenticationCheck;
function mockGetAuthenticationCheckSuccess(data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/authentication_check/`, "get", 200, data, options);
}
exports.mockGetAuthenticationCheckSuccess = mockGetAuthenticationCheckSuccess;
function mockGetAuthenticationCheckFailure(options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/authentication_check/`, "get", 400, failureResponse, options);
}
exports.mockGetAuthenticationCheckFailure = mockGetAuthenticationCheckFailure;
/**
 * Get user CBILS eligibility self assessment data
 */
function fetchGetCbilsEligibilitySelfAssessment({ stateKey, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/cbils_eligibility_self_assessment/${stateKey}/`, {
        method: "get",
        version: "edge",
    });
}
exports.fetchGetCbilsEligibilitySelfAssessment = fetchGetCbilsEligibilitySelfAssessment;
function mockGetCbilsEligibilitySelfAssessmentSuccess(stateKey, data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/cbils_eligibility_self_assessment/${stateKey}/`, "get", 200, data, options);
}
exports.mockGetCbilsEligibilitySelfAssessmentSuccess = mockGetCbilsEligibilitySelfAssessmentSuccess;
function mockGetCbilsEligibilitySelfAssessmentFailure(stateKey, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/cbils_eligibility_self_assessment/${stateKey}/`, "get", 400, failureResponse, options);
}
exports.mockGetCbilsEligibilitySelfAssessmentFailure = mockGetCbilsEligibilitySelfAssessmentFailure;
/**
 * The data returned contains information like approval status, loan status, repayments, cashflows, ...
 */
function fetchGetCreditFacilityStatus({ stateKey, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/credit_facility_status/${stateKey}/`, {
        method: "get",
        version: "edge",
    });
}
exports.fetchGetCreditFacilityStatus = fetchGetCreditFacilityStatus;
function mockGetCreditFacilityStatusSuccess(stateKey, data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/credit_facility_status/${stateKey}/`, "get", 200, data, options);
}
exports.mockGetCreditFacilityStatusSuccess = mockGetCreditFacilityStatusSuccess;
function mockGetCreditFacilityStatusFailure(stateKey, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/credit_facility_status/${stateKey}/`, "get", 400, failureResponse, options);
}
exports.mockGetCreditFacilityStatusFailure = mockGetCreditFacilityStatusFailure;
/**
 * No description
 */
function fetchGetDocumentUpload({ stateKey, query, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/document_upload/${stateKey}/`, {
        method: "get",
        version: "edge",
        query,
    });
}
exports.fetchGetDocumentUpload = fetchGetDocumentUpload;
function mockGetDocumentUploadSuccess(stateKey, data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/document_upload/${stateKey}/`, "get", 200, data, options);
}
exports.mockGetDocumentUploadSuccess = mockGetDocumentUploadSuccess;
function mockGetDocumentUploadFailure(stateKey, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/document_upload/${stateKey}/`, "get", 400, failureResponse, options);
}
exports.mockGetDocumentUploadFailure = mockGetDocumentUploadFailure;
/**
 * No description
 */
function fetchPostDocumentUpload({ stateKey, body, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/document_upload/${stateKey}/`, {
        method: "post",
        version: "edge",
        body,
    });
}
exports.fetchPostDocumentUpload = fetchPostDocumentUpload;
function mockPostDocumentUploadSuccess(stateKey, data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/document_upload/${stateKey}/`, "post", 201, data, options);
}
exports.mockPostDocumentUploadSuccess = mockPostDocumentUploadSuccess;
function mockPostDocumentUploadFailure(stateKey, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/document_upload/${stateKey}/`, "post", 400, failureResponse, options);
}
exports.mockPostDocumentUploadFailure = mockPostDocumentUploadFailure;
/**
 * No description
 */
function fetchPutDocumentUpload({ stateKey, documentId, body, }) {
    return (0, lendingAPI_1.fetchLendingAPI)(`/document_upload/${stateKey}/${documentId}/`, {
        method: "put",
        version: "edge",
        body,
    });
}
exports.fetchPutDocumentUpload = fetchPutDocumentUpload;
function mockPutDocumentUploadSuccess(stateKey, documentId, data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/document_upload/${stateKey}/${documentId}/`, "put", 202, data, options);
}
exports.mockPutDocumentUploadSuccess = mockPutDocumentUploadSuccess;
function mockPutDocumentUploadFailure(stateKey, documentId, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/document_upload/${stateKey}/${documentId}/`, "put", 400, failureResponse, options);
}
exports.mockPutDocumentUploadFailure = mockPutDocumentUploadFailure;
/**
 * Returns the simulated repayment schedule for the given formal offer as if the customer was completing a funding today.
 */
function fetchGetDrawDownRepaymentScheduleIwocapay({ stateKey, offerId, query, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/draw_down_repayment_schedule/${stateKey}/iwocapay/${offerId}/`, {
        method: "get",
        version: "edge",
        query,
    });
}
exports.fetchGetDrawDownRepaymentScheduleIwocapay = fetchGetDrawDownRepaymentScheduleIwocapay;
function mockGetDrawDownRepaymentScheduleIwocapaySuccess(stateKey, offerId, data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/draw_down_repayment_schedule/${stateKey}/iwocapay/${offerId}/`, "get", 200, data, options);
}
exports.mockGetDrawDownRepaymentScheduleIwocapaySuccess = mockGetDrawDownRepaymentScheduleIwocapaySuccess;
function mockGetDrawDownRepaymentScheduleIwocapayFailure(stateKey, offerId, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/draw_down_repayment_schedule/${stateKey}/iwocapay/${offerId}/`, "get", 400, failureResponse, options);
}
exports.mockGetDrawDownRepaymentScheduleIwocapayFailure = mockGetDrawDownRepaymentScheduleIwocapayFailure;
/**
 * Returns the simulated repayment schedule for the given account where an early repayment of the given amount was made at the time of the request.
 */
function fetchGetEarlyRepaymentSimulation({ stateKey, accountId, query, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/early_repayment_simulation/${stateKey}/${accountId}/`, {
        method: "get",
        version: "edge",
        query,
    });
}
exports.fetchGetEarlyRepaymentSimulation = fetchGetEarlyRepaymentSimulation;
function mockGetEarlyRepaymentSimulationSuccess(stateKey, accountId, data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/early_repayment_simulation/${stateKey}/${accountId}/`, "get", 200, data, options);
}
exports.mockGetEarlyRepaymentSimulationSuccess = mockGetEarlyRepaymentSimulationSuccess;
function mockGetEarlyRepaymentSimulationFailure(stateKey, accountId, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/early_repayment_simulation/${stateKey}/${accountId}/`, "get", 400, failureResponse, options);
}
exports.mockGetEarlyRepaymentSimulationFailure = mockGetEarlyRepaymentSimulationFailure;
/**
 * No description
 */
function fetchGetEcommerceOrder({ orderId }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/ecommerce/order/${orderId}/`, {
        method: "get",
        version: "edge",
    });
}
exports.fetchGetEcommerceOrder = fetchGetEcommerceOrder;
function mockGetEcommerceOrderSuccess(orderId, data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/ecommerce/order/${orderId}/`, "get", 200, data, options);
}
exports.mockGetEcommerceOrderSuccess = mockGetEcommerceOrderSuccess;
function mockGetEcommerceOrderFailure(orderId, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/ecommerce/order/${orderId}/`, "get", 400, failureResponse, options);
}
exports.mockGetEcommerceOrderFailure = mockGetEcommerceOrderFailure;
/**
 * No description
 */
function fetchPostEcommerceSellerOrder({ sellerId, body, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/ecommerce/seller/${sellerId}/order/`, {
        method: "post",
        version: "edge",
        body,
    });
}
exports.fetchPostEcommerceSellerOrder = fetchPostEcommerceSellerOrder;
function mockPostEcommerceSellerOrderSuccess(sellerId, data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/ecommerce/seller/${sellerId}/order/`, "post", 201, data, options);
}
exports.mockPostEcommerceSellerOrderSuccess = mockPostEcommerceSellerOrderSuccess;
function mockPostEcommerceSellerOrderFailure(sellerId, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/ecommerce/seller/${sellerId}/order/`, "post", 400, failureResponse, options);
}
exports.mockPostEcommerceSellerOrderFailure = mockPostEcommerceSellerOrderFailure;
/**
 * No description
 */
function fetchGetExampleRepaymentSchedule({ query, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/example_repayment_schedule/`, {
        method: "get",
        version: "edge",
        query,
    });
}
exports.fetchGetExampleRepaymentSchedule = fetchGetExampleRepaymentSchedule;
function mockGetExampleRepaymentScheduleSuccess(data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/example_repayment_schedule/`, "get", 200, data, options);
}
exports.mockGetExampleRepaymentScheduleSuccess = mockGetExampleRepaymentScheduleSuccess;
function mockGetExampleRepaymentScheduleFailure(options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/example_repayment_schedule/`, "get", 400, failureResponse, options);
}
exports.mockGetExampleRepaymentScheduleFailure = mockGetExampleRepaymentScheduleFailure;
/**
 * No description
 */
function fetchGetExampleRepaymentScheduleSummaries({ query, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/example_repayment_schedule_summaries/`, {
        method: "get",
        version: "edge",
        query,
    });
}
exports.fetchGetExampleRepaymentScheduleSummaries = fetchGetExampleRepaymentScheduleSummaries;
function mockGetExampleRepaymentScheduleSummariesSuccess(data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/example_repayment_schedule_summaries/`, "get", 200, data, options);
}
exports.mockGetExampleRepaymentScheduleSummariesSuccess = mockGetExampleRepaymentScheduleSummariesSuccess;
function mockGetExampleRepaymentScheduleSummariesFailure(options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/example_repayment_schedule_summaries/`, "get", 400, failureResponse, options);
}
exports.mockGetExampleRepaymentScheduleSummariesFailure = mockGetExampleRepaymentScheduleSummariesFailure;
/**
 * No description
 */
function fetchGetFormalIndicativeOffers({ stateKey, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/formal_indicative_offers/${stateKey}/`, {
        method: "get",
        version: "edge",
    });
}
exports.fetchGetFormalIndicativeOffers = fetchGetFormalIndicativeOffers;
function mockGetFormalIndicativeOffersSuccess(stateKey, data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/formal_indicative_offers/${stateKey}/`, "get", 200, data, options);
}
exports.mockGetFormalIndicativeOffersSuccess = mockGetFormalIndicativeOffersSuccess;
function mockGetFormalIndicativeOffersFailure(stateKey, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/formal_indicative_offers/${stateKey}/`, "get", 400, failureResponse, options);
}
exports.mockGetFormalIndicativeOffersFailure = mockGetFormalIndicativeOffersFailure;
/**
 * Create formal indicative offers
 */
function fetchPostFormalIndicativeOffers({ stateKey, body, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/formal_indicative_offers/${stateKey}/`, {
        method: "post",
        version: "edge",
        body,
    });
}
exports.fetchPostFormalIndicativeOffers = fetchPostFormalIndicativeOffers;
function mockPostFormalIndicativeOffersSuccess(stateKey, data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/formal_indicative_offers/${stateKey}/`, "post", 201, data, options);
}
exports.mockPostFormalIndicativeOffersSuccess = mockPostFormalIndicativeOffersSuccess;
function mockPostFormalIndicativeOffersFailure(stateKey, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/formal_indicative_offers/${stateKey}/`, "post", 400, failureResponse, options);
}
exports.mockPostFormalIndicativeOffersFailure = mockPostFormalIndicativeOffersFailure;
/**
 * No description
 */
function fetchGetFormalOffers({ stateKey }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/formal_offers/${stateKey}/`, {
        method: "get",
        version: "edge",
    });
}
exports.fetchGetFormalOffers = fetchGetFormalOffers;
function mockGetFormalOffersSuccess(stateKey, data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/formal_offers/${stateKey}/`, "get", 200, data, options);
}
exports.mockGetFormalOffersSuccess = mockGetFormalOffersSuccess;
function mockGetFormalOffersFailure(stateKey, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/formal_offers/${stateKey}/`, "get", 400, failureResponse, options);
}
exports.mockGetFormalOffersFailure = mockGetFormalOffersFailure;
/**
 * No description
 */
function fetchPostFormalOffers({ stateKey, body, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/formal_offers/${stateKey}/`, {
        method: "post",
        version: "edge",
        body,
    });
}
exports.fetchPostFormalOffers = fetchPostFormalOffers;
function mockPostFormalOffersSuccess(stateKey, data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/formal_offers/${stateKey}/`, "post", 201, data, options);
}
exports.mockPostFormalOffersSuccess = mockPostFormalOffersSuccess;
function mockPostFormalOffersFailure(stateKey, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/formal_offers/${stateKey}/`, "post", 400, failureResponse, options);
}
exports.mockPostFormalOffersFailure = mockPostFormalOffersFailure;
/**
 * Get the parameters the customer anticipates using for a business_loan offer at drawdown.
 */
function fetchGetFormalOffersBusinessLoanConfiguration({ stateKey, offerId, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/formal_offers/${stateKey}/business_loan/${offerId}/configuration/`, {
        method: "get",
        version: "edge",
    });
}
exports.fetchGetFormalOffersBusinessLoanConfiguration = fetchGetFormalOffersBusinessLoanConfiguration;
function mockGetFormalOffersBusinessLoanConfigurationSuccess(stateKey, offerId, data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/formal_offers/${stateKey}/business_loan/${offerId}/configuration/`, "get", 200, data, options);
}
exports.mockGetFormalOffersBusinessLoanConfigurationSuccess = mockGetFormalOffersBusinessLoanConfigurationSuccess;
function mockGetFormalOffersBusinessLoanConfigurationFailure(stateKey, offerId, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/formal_offers/${stateKey}/business_loan/${offerId}/configuration/`, "get", 400, failureResponse, options);
}
exports.mockGetFormalOffersBusinessLoanConfigurationFailure = mockGetFormalOffersBusinessLoanConfigurationFailure;
/**
 * Update the parameters teh customer anticipates using for a business_loan offer at drawdown.
 */
function fetchPutFormalOffersBusinessLoanConfiguration({ stateKey, offerId, body, }) {
    return (0, lendingAPI_1.fetchLendingAPI)(`/formal_offers/${stateKey}/business_loan/${offerId}/configuration/`, {
        method: "put",
        version: "edge",
        body,
    });
}
exports.fetchPutFormalOffersBusinessLoanConfiguration = fetchPutFormalOffersBusinessLoanConfiguration;
function mockPutFormalOffersBusinessLoanConfigurationSuccess(stateKey, offerId, data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/formal_offers/${stateKey}/business_loan/${offerId}/configuration/`, "put", 202, data, options);
}
exports.mockPutFormalOffersBusinessLoanConfigurationSuccess = mockPutFormalOffersBusinessLoanConfigurationSuccess;
function mockPutFormalOffersBusinessLoanConfigurationFailure(stateKey, offerId, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/formal_offers/${stateKey}/business_loan/${offerId}/configuration/`, "put", 400, failureResponse, options);
}
exports.mockPutFormalOffersBusinessLoanConfigurationFailure = mockPutFormalOffersBusinessLoanConfigurationFailure;
/**
 * Get the parameters the customer anticipates using for a cbils offer at drawdown.
 */
function fetchGetFormalOffersCbilsConfiguration({ stateKey, offerId, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/formal_offers/${stateKey}/cbils/${offerId}/configuration/`, {
        method: "get",
        version: "edge",
    });
}
exports.fetchGetFormalOffersCbilsConfiguration = fetchGetFormalOffersCbilsConfiguration;
function mockGetFormalOffersCbilsConfigurationSuccess(stateKey, offerId, data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/formal_offers/${stateKey}/cbils/${offerId}/configuration/`, "get", 200, data, options);
}
exports.mockGetFormalOffersCbilsConfigurationSuccess = mockGetFormalOffersCbilsConfigurationSuccess;
function mockGetFormalOffersCbilsConfigurationFailure(stateKey, offerId, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/formal_offers/${stateKey}/cbils/${offerId}/configuration/`, "get", 400, failureResponse, options);
}
exports.mockGetFormalOffersCbilsConfigurationFailure = mockGetFormalOffersCbilsConfigurationFailure;
/**
 * Update the parameters teh customer anticipates using for a cbils offer at drawdown.
 */
function fetchPutFormalOffersCbilsConfiguration({ stateKey, offerId, body, }) {
    return (0, lendingAPI_1.fetchLendingAPI)(`/formal_offers/${stateKey}/cbils/${offerId}/configuration/`, {
        method: "put",
        version: "edge",
        body,
    });
}
exports.fetchPutFormalOffersCbilsConfiguration = fetchPutFormalOffersCbilsConfiguration;
function mockPutFormalOffersCbilsConfigurationSuccess(stateKey, offerId, data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/formal_offers/${stateKey}/cbils/${offerId}/configuration/`, "put", 202, data, options);
}
exports.mockPutFormalOffersCbilsConfigurationSuccess = mockPutFormalOffersCbilsConfigurationSuccess;
function mockPutFormalOffersCbilsConfigurationFailure(stateKey, offerId, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/formal_offers/${stateKey}/cbils/${offerId}/configuration/`, "put", 400, failureResponse, options);
}
exports.mockPutFormalOffersCbilsConfigurationFailure = mockPutFormalOffersCbilsConfigurationFailure;
/**
 * Get the parameters the customer anticipates using for a credit_facility offer at drawdown.
 */
function fetchGetFormalOffersCreditFacilityConfiguration({ stateKey, offerId, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/formal_offers/${stateKey}/credit_facility/${offerId}/configuration/`, {
        method: "get",
        version: "edge",
    });
}
exports.fetchGetFormalOffersCreditFacilityConfiguration = fetchGetFormalOffersCreditFacilityConfiguration;
function mockGetFormalOffersCreditFacilityConfigurationSuccess(stateKey, offerId, data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/formal_offers/${stateKey}/credit_facility/${offerId}/configuration/`, "get", 200, data, options);
}
exports.mockGetFormalOffersCreditFacilityConfigurationSuccess = mockGetFormalOffersCreditFacilityConfigurationSuccess;
function mockGetFormalOffersCreditFacilityConfigurationFailure(stateKey, offerId, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/formal_offers/${stateKey}/credit_facility/${offerId}/configuration/`, "get", 400, failureResponse, options);
}
exports.mockGetFormalOffersCreditFacilityConfigurationFailure = mockGetFormalOffersCreditFacilityConfigurationFailure;
/**
 * Update the parameters teh customer anticipates using for a credit_facility offer at drawdown.
 */
function fetchPutFormalOffersCreditFacilityConfiguration({ stateKey, offerId, body, }) {
    return (0, lendingAPI_1.fetchLendingAPI)(`/formal_offers/${stateKey}/credit_facility/${offerId}/configuration/`, {
        method: "put",
        version: "edge",
        body,
    });
}
exports.fetchPutFormalOffersCreditFacilityConfiguration = fetchPutFormalOffersCreditFacilityConfiguration;
function mockPutFormalOffersCreditFacilityConfigurationSuccess(stateKey, offerId, data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/formal_offers/${stateKey}/credit_facility/${offerId}/configuration/`, "put", 202, data, options);
}
exports.mockPutFormalOffersCreditFacilityConfigurationSuccess = mockPutFormalOffersCreditFacilityConfigurationSuccess;
function mockPutFormalOffersCreditFacilityConfigurationFailure(stateKey, offerId, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/formal_offers/${stateKey}/credit_facility/${offerId}/configuration/`, "put", 400, failureResponse, options);
}
exports.mockPutFormalOffersCreditFacilityConfigurationFailure = mockPutFormalOffersCreditFacilityConfigurationFailure;
/**
 * Get the parameters the customer anticipates using for a flexi24 offer at drawdown.
 */
function fetchGetFormalOffersFlexi24Configuration({ stateKey, offerId, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/formal_offers/${stateKey}/flexi24/${offerId}/configuration/`, {
        method: "get",
        version: "edge",
    });
}
exports.fetchGetFormalOffersFlexi24Configuration = fetchGetFormalOffersFlexi24Configuration;
function mockGetFormalOffersFlexi24ConfigurationSuccess(stateKey, offerId, data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/formal_offers/${stateKey}/flexi24/${offerId}/configuration/`, "get", 200, data, options);
}
exports.mockGetFormalOffersFlexi24ConfigurationSuccess = mockGetFormalOffersFlexi24ConfigurationSuccess;
function mockGetFormalOffersFlexi24ConfigurationFailure(stateKey, offerId, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/formal_offers/${stateKey}/flexi24/${offerId}/configuration/`, "get", 400, failureResponse, options);
}
exports.mockGetFormalOffersFlexi24ConfigurationFailure = mockGetFormalOffersFlexi24ConfigurationFailure;
/**
 * Update the parameters teh customer anticipates using for a flexi24 offer at drawdown.
 */
function fetchPutFormalOffersFlexi24Configuration({ stateKey, offerId, body, }) {
    return (0, lendingAPI_1.fetchLendingAPI)(`/formal_offers/${stateKey}/flexi24/${offerId}/configuration/`, {
        method: "put",
        version: "edge",
        body,
    });
}
exports.fetchPutFormalOffersFlexi24Configuration = fetchPutFormalOffersFlexi24Configuration;
function mockPutFormalOffersFlexi24ConfigurationSuccess(stateKey, offerId, data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/formal_offers/${stateKey}/flexi24/${offerId}/configuration/`, "put", 202, data, options);
}
exports.mockPutFormalOffersFlexi24ConfigurationSuccess = mockPutFormalOffersFlexi24ConfigurationSuccess;
function mockPutFormalOffersFlexi24ConfigurationFailure(stateKey, offerId, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/formal_offers/${stateKey}/flexi24/${offerId}/configuration/`, "put", 400, failureResponse, options);
}
exports.mockPutFormalOffersFlexi24ConfigurationFailure = mockPutFormalOffersFlexi24ConfigurationFailure;
/**
 * Get the parameters the customer anticipates using for a iwocapay offer at drawdown.
 */
function fetchGetFormalOffersIwocapayConfiguration({ stateKey, offerId, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/formal_offers/${stateKey}/iwocapay/${offerId}/configuration/`, {
        method: "get",
        version: "edge",
    });
}
exports.fetchGetFormalOffersIwocapayConfiguration = fetchGetFormalOffersIwocapayConfiguration;
function mockGetFormalOffersIwocapayConfigurationSuccess(stateKey, offerId, data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/formal_offers/${stateKey}/iwocapay/${offerId}/configuration/`, "get", 200, data, options);
}
exports.mockGetFormalOffersIwocapayConfigurationSuccess = mockGetFormalOffersIwocapayConfigurationSuccess;
function mockGetFormalOffersIwocapayConfigurationFailure(stateKey, offerId, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/formal_offers/${stateKey}/iwocapay/${offerId}/configuration/`, "get", 400, failureResponse, options);
}
exports.mockGetFormalOffersIwocapayConfigurationFailure = mockGetFormalOffersIwocapayConfigurationFailure;
/**
 * Update the parameters teh customer anticipates using for a iwocapay offer at drawdown.
 */
function fetchPutFormalOffersIwocapayConfiguration({ stateKey, offerId, body, }) {
    return (0, lendingAPI_1.fetchLendingAPI)(`/formal_offers/${stateKey}/iwocapay/${offerId}/configuration/`, {
        method: "put",
        version: "edge",
        body,
    });
}
exports.fetchPutFormalOffersIwocapayConfiguration = fetchPutFormalOffersIwocapayConfiguration;
function mockPutFormalOffersIwocapayConfigurationSuccess(stateKey, offerId, data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/formal_offers/${stateKey}/iwocapay/${offerId}/configuration/`, "put", 202, data, options);
}
exports.mockPutFormalOffersIwocapayConfigurationSuccess = mockPutFormalOffersIwocapayConfigurationSuccess;
function mockPutFormalOffersIwocapayConfigurationFailure(stateKey, offerId, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/formal_offers/${stateKey}/iwocapay/${offerId}/configuration/`, "put", 400, failureResponse, options);
}
exports.mockPutFormalOffersIwocapayConfigurationFailure = mockPutFormalOffersIwocapayConfigurationFailure;
/**
 * Get the parameters the customer anticipates using for a merchant_cash_advance offer at drawdown.
 */
function fetchGetFormalOffersMerchantCashAdvanceConfiguration({ stateKey, offerId, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/formal_offers/${stateKey}/merchant_cash_advance/${offerId}/configuration/`, {
        method: "get",
        version: "edge",
    });
}
exports.fetchGetFormalOffersMerchantCashAdvanceConfiguration = fetchGetFormalOffersMerchantCashAdvanceConfiguration;
function mockGetFormalOffersMerchantCashAdvanceConfigurationSuccess(stateKey, offerId, data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/formal_offers/${stateKey}/merchant_cash_advance/${offerId}/configuration/`, "get", 200, data, options);
}
exports.mockGetFormalOffersMerchantCashAdvanceConfigurationSuccess = mockGetFormalOffersMerchantCashAdvanceConfigurationSuccess;
function mockGetFormalOffersMerchantCashAdvanceConfigurationFailure(stateKey, offerId, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/formal_offers/${stateKey}/merchant_cash_advance/${offerId}/configuration/`, "get", 400, failureResponse, options);
}
exports.mockGetFormalOffersMerchantCashAdvanceConfigurationFailure = mockGetFormalOffersMerchantCashAdvanceConfigurationFailure;
/**
 * Update the parameters teh customer anticipates using for a merchant_cash_advance offer at drawdown.
 */
function fetchPutFormalOffersMerchantCashAdvanceConfiguration({ stateKey, offerId, body, }) {
    return (0, lendingAPI_1.fetchLendingAPI)(`/formal_offers/${stateKey}/merchant_cash_advance/${offerId}/configuration/`, {
        method: "put",
        version: "edge",
        body,
    });
}
exports.fetchPutFormalOffersMerchantCashAdvanceConfiguration = fetchPutFormalOffersMerchantCashAdvanceConfiguration;
function mockPutFormalOffersMerchantCashAdvanceConfigurationSuccess(stateKey, offerId, data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/formal_offers/${stateKey}/merchant_cash_advance/${offerId}/configuration/`, "put", 202, data, options);
}
exports.mockPutFormalOffersMerchantCashAdvanceConfigurationSuccess = mockPutFormalOffersMerchantCashAdvanceConfigurationSuccess;
function mockPutFormalOffersMerchantCashAdvanceConfigurationFailure(stateKey, offerId, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/formal_offers/${stateKey}/merchant_cash_advance/${offerId}/configuration/`, "put", 400, failureResponse, options);
}
exports.mockPutFormalOffersMerchantCashAdvanceConfigurationFailure = mockPutFormalOffersMerchantCashAdvanceConfigurationFailure;
/**
 * Get the parameters the customer anticipates using for a recovery_loan offer at drawdown.
 */
function fetchGetFormalOffersRecoveryLoanConfiguration({ stateKey, offerId, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/formal_offers/${stateKey}/recovery_loan/${offerId}/configuration/`, {
        method: "get",
        version: "edge",
    });
}
exports.fetchGetFormalOffersRecoveryLoanConfiguration = fetchGetFormalOffersRecoveryLoanConfiguration;
function mockGetFormalOffersRecoveryLoanConfigurationSuccess(stateKey, offerId, data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/formal_offers/${stateKey}/recovery_loan/${offerId}/configuration/`, "get", 200, data, options);
}
exports.mockGetFormalOffersRecoveryLoanConfigurationSuccess = mockGetFormalOffersRecoveryLoanConfigurationSuccess;
function mockGetFormalOffersRecoveryLoanConfigurationFailure(stateKey, offerId, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/formal_offers/${stateKey}/recovery_loan/${offerId}/configuration/`, "get", 400, failureResponse, options);
}
exports.mockGetFormalOffersRecoveryLoanConfigurationFailure = mockGetFormalOffersRecoveryLoanConfigurationFailure;
/**
 * Update the parameters teh customer anticipates using for a recovery_loan offer at drawdown.
 */
function fetchPutFormalOffersRecoveryLoanConfiguration({ stateKey, offerId, body, }) {
    return (0, lendingAPI_1.fetchLendingAPI)(`/formal_offers/${stateKey}/recovery_loan/${offerId}/configuration/`, {
        method: "put",
        version: "edge",
        body,
    });
}
exports.fetchPutFormalOffersRecoveryLoanConfiguration = fetchPutFormalOffersRecoveryLoanConfiguration;
function mockPutFormalOffersRecoveryLoanConfigurationSuccess(stateKey, offerId, data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/formal_offers/${stateKey}/recovery_loan/${offerId}/configuration/`, "put", 202, data, options);
}
exports.mockPutFormalOffersRecoveryLoanConfigurationSuccess = mockPutFormalOffersRecoveryLoanConfigurationSuccess;
function mockPutFormalOffersRecoveryLoanConfigurationFailure(stateKey, offerId, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/formal_offers/${stateKey}/recovery_loan/${offerId}/configuration/`, "put", 400, failureResponse, options);
}
exports.mockPutFormalOffersRecoveryLoanConfigurationFailure = mockPutFormalOffersRecoveryLoanConfigurationFailure;
/**
 * No description
 */
function fetchPostFundSellerRequest({ stateKey, payLinkId, body, }) {
    return (0, lendingAPI_1.fetchLendingAPI)(`/fund_seller_request/${stateKey}/${payLinkId}/`, {
        method: "post",
        version: "edge",
        body,
    });
}
exports.fetchPostFundSellerRequest = fetchPostFundSellerRequest;
function mockPostFundSellerRequestSuccess(stateKey, payLinkId, data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/fund_seller_request/${stateKey}/${payLinkId}/`, "post", 201, data, options);
}
exports.mockPostFundSellerRequestSuccess = mockPostFundSellerRequestSuccess;
function mockPostFundSellerRequestFailure(stateKey, payLinkId, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/fund_seller_request/${stateKey}/${payLinkId}/`, "post", 400, failureResponse, options);
}
exports.mockPostFundSellerRequestFailure = mockPostFundSellerRequestFailure;
/**
 * No description
 */
function fetchPostFundingRequestBusinessLoan({ stateKey, offerId, body, }) {
    return (0, lendingAPI_1.fetchLendingAPI)(`/funding_request/${stateKey}/business_loan/${offerId}/`, {
        method: "post",
        version: "edge",
        body,
    });
}
exports.fetchPostFundingRequestBusinessLoan = fetchPostFundingRequestBusinessLoan;
function mockPostFundingRequestBusinessLoanSuccess(stateKey, offerId, data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/funding_request/${stateKey}/business_loan/${offerId}/`, "post", 201, data, options);
}
exports.mockPostFundingRequestBusinessLoanSuccess = mockPostFundingRequestBusinessLoanSuccess;
function mockPostFundingRequestBusinessLoanFailure(stateKey, offerId, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/funding_request/${stateKey}/business_loan/${offerId}/`, "post", 400, failureResponse, options);
}
exports.mockPostFundingRequestBusinessLoanFailure = mockPostFundingRequestBusinessLoanFailure;
/**
 * No description
 */
function fetchPostFundingRequestCbils({ stateKey, offerId, body, }) {
    return (0, lendingAPI_1.fetchLendingAPI)(`/funding_request/${stateKey}/cbils/${offerId}/`, {
        method: "post",
        version: "edge",
        body,
    });
}
exports.fetchPostFundingRequestCbils = fetchPostFundingRequestCbils;
function mockPostFundingRequestCbilsSuccess(stateKey, offerId, data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/funding_request/${stateKey}/cbils/${offerId}/`, "post", 201, data, options);
}
exports.mockPostFundingRequestCbilsSuccess = mockPostFundingRequestCbilsSuccess;
function mockPostFundingRequestCbilsFailure(stateKey, offerId, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/funding_request/${stateKey}/cbils/${offerId}/`, "post", 400, failureResponse, options);
}
exports.mockPostFundingRequestCbilsFailure = mockPostFundingRequestCbilsFailure;
/**
 * No description
 */
function fetchPostFundingRequestCreditFacility({ stateKey, offerId, body, }) {
    return (0, lendingAPI_1.fetchLendingAPI)(`/funding_request/${stateKey}/credit_facility/${offerId}/`, {
        method: "post",
        version: "edge",
        body,
    });
}
exports.fetchPostFundingRequestCreditFacility = fetchPostFundingRequestCreditFacility;
function mockPostFundingRequestCreditFacilitySuccess(stateKey, offerId, data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/funding_request/${stateKey}/credit_facility/${offerId}/`, "post", 201, data, options);
}
exports.mockPostFundingRequestCreditFacilitySuccess = mockPostFundingRequestCreditFacilitySuccess;
function mockPostFundingRequestCreditFacilityFailure(stateKey, offerId, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/funding_request/${stateKey}/credit_facility/${offerId}/`, "post", 400, failureResponse, options);
}
exports.mockPostFundingRequestCreditFacilityFailure = mockPostFundingRequestCreditFacilityFailure;
/**
 * No description
 */
function fetchPostFundingRequestFlexi24({ stateKey, offerId, body, }) {
    return (0, lendingAPI_1.fetchLendingAPI)(`/funding_request/${stateKey}/flexi24/${offerId}/`, {
        method: "post",
        version: "edge",
        body,
    });
}
exports.fetchPostFundingRequestFlexi24 = fetchPostFundingRequestFlexi24;
function mockPostFundingRequestFlexi24Success(stateKey, offerId, data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/funding_request/${stateKey}/flexi24/${offerId}/`, "post", 201, data, options);
}
exports.mockPostFundingRequestFlexi24Success = mockPostFundingRequestFlexi24Success;
function mockPostFundingRequestFlexi24Failure(stateKey, offerId, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/funding_request/${stateKey}/flexi24/${offerId}/`, "post", 400, failureResponse, options);
}
exports.mockPostFundingRequestFlexi24Failure = mockPostFundingRequestFlexi24Failure;
/**
 * No description
 */
function fetchPostFundingRequestIwocapay({ stateKey, offerId, body, }) {
    return (0, lendingAPI_1.fetchLendingAPI)(`/funding_request/${stateKey}/iwocapay/${offerId}/`, {
        method: "post",
        version: "edge",
        body,
    });
}
exports.fetchPostFundingRequestIwocapay = fetchPostFundingRequestIwocapay;
function mockPostFundingRequestIwocapaySuccess(stateKey, offerId, data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/funding_request/${stateKey}/iwocapay/${offerId}/`, "post", 201, data, options);
}
exports.mockPostFundingRequestIwocapaySuccess = mockPostFundingRequestIwocapaySuccess;
function mockPostFundingRequestIwocapayFailure(stateKey, offerId, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/funding_request/${stateKey}/iwocapay/${offerId}/`, "post", 400, failureResponse, options);
}
exports.mockPostFundingRequestIwocapayFailure = mockPostFundingRequestIwocapayFailure;
/**
 * No description
 */
function fetchPostFundingRequestMerchantCashAdvance({ stateKey, offerId, body, }) {
    return (0, lendingAPI_1.fetchLendingAPI)(`/funding_request/${stateKey}/merchant_cash_advance/${offerId}/`, {
        method: "post",
        version: "edge",
        body,
    });
}
exports.fetchPostFundingRequestMerchantCashAdvance = fetchPostFundingRequestMerchantCashAdvance;
function mockPostFundingRequestMerchantCashAdvanceSuccess(stateKey, offerId, data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/funding_request/${stateKey}/merchant_cash_advance/${offerId}/`, "post", 201, data, options);
}
exports.mockPostFundingRequestMerchantCashAdvanceSuccess = mockPostFundingRequestMerchantCashAdvanceSuccess;
function mockPostFundingRequestMerchantCashAdvanceFailure(stateKey, offerId, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/funding_request/${stateKey}/merchant_cash_advance/${offerId}/`, "post", 400, failureResponse, options);
}
exports.mockPostFundingRequestMerchantCashAdvanceFailure = mockPostFundingRequestMerchantCashAdvanceFailure;
/**
 * No description
 */
function fetchPostFundingRequestRecoveryLoan({ stateKey, offerId, body, }) {
    return (0, lendingAPI_1.fetchLendingAPI)(`/funding_request/${stateKey}/recovery_loan/${offerId}/`, {
        method: "post",
        version: "edge",
        body,
    });
}
exports.fetchPostFundingRequestRecoveryLoan = fetchPostFundingRequestRecoveryLoan;
function mockPostFundingRequestRecoveryLoanSuccess(stateKey, offerId, data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/funding_request/${stateKey}/recovery_loan/${offerId}/`, "post", 201, data, options);
}
exports.mockPostFundingRequestRecoveryLoanSuccess = mockPostFundingRequestRecoveryLoanSuccess;
function mockPostFundingRequestRecoveryLoanFailure(stateKey, offerId, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/funding_request/${stateKey}/recovery_loan/${offerId}/`, "post", 400, failureResponse, options);
}
exports.mockPostFundingRequestRecoveryLoanFailure = mockPostFundingRequestRecoveryLoanFailure;
/**
 * To accurately return the
funding requirements that are checked on funding, all available
url parameters should be provided.

If not all url paramaters are provided, the system will
make a guess based on any offer configuration and other features
of the offer.

Parameters that are not available in the offer configuration
endpoint are unlikely to substantially affect funding parameters,
but it is still advisable to provide as complete information
as possible.

 */
function fetchGetFundingRequirementsBusinessLoan({ stateKey, offerId, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/funding_requirements/${stateKey}/business_loan/${offerId}/`, {
        method: "get",
        version: "edge",
    });
}
exports.fetchGetFundingRequirementsBusinessLoan = fetchGetFundingRequirementsBusinessLoan;
function mockGetFundingRequirementsBusinessLoanSuccess(stateKey, offerId, data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/funding_requirements/${stateKey}/business_loan/${offerId}/`, "get", 200, data, options);
}
exports.mockGetFundingRequirementsBusinessLoanSuccess = mockGetFundingRequirementsBusinessLoanSuccess;
function mockGetFundingRequirementsBusinessLoanFailure(stateKey, offerId, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/funding_requirements/${stateKey}/business_loan/${offerId}/`, "get", 400, failureResponse, options);
}
exports.mockGetFundingRequirementsBusinessLoanFailure = mockGetFundingRequirementsBusinessLoanFailure;
/**
 * To accurately return the
funding requirements that are checked on funding, all available
url parameters should be provided.

If not all url paramaters are provided, the system will
make a guess based on any offer configuration and other features
of the offer.

Parameters that are not available in the offer configuration
endpoint are unlikely to substantially affect funding parameters,
but it is still advisable to provide as complete information
as possible.

 */
function fetchGetFundingRequirementsCbils({ stateKey, offerId, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/funding_requirements/${stateKey}/cbils/${offerId}/`, {
        method: "get",
        version: "edge",
    });
}
exports.fetchGetFundingRequirementsCbils = fetchGetFundingRequirementsCbils;
function mockGetFundingRequirementsCbilsSuccess(stateKey, offerId, data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/funding_requirements/${stateKey}/cbils/${offerId}/`, "get", 200, data, options);
}
exports.mockGetFundingRequirementsCbilsSuccess = mockGetFundingRequirementsCbilsSuccess;
function mockGetFundingRequirementsCbilsFailure(stateKey, offerId, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/funding_requirements/${stateKey}/cbils/${offerId}/`, "get", 400, failureResponse, options);
}
exports.mockGetFundingRequirementsCbilsFailure = mockGetFundingRequirementsCbilsFailure;
/**
 * To accurately return the
funding requirements that are checked on funding, all available
url parameters should be provided.

If not all url paramaters are provided, the system will
make a guess based on any offer configuration and other features
of the offer.

Parameters that are not available in the offer configuration
endpoint are unlikely to substantially affect funding parameters,
but it is still advisable to provide as complete information
as possible.

 */
function fetchGetFundingRequirementsCreditFacility({ stateKey, offerId, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/funding_requirements/${stateKey}/credit_facility/${offerId}/`, {
        method: "get",
        version: "edge",
    });
}
exports.fetchGetFundingRequirementsCreditFacility = fetchGetFundingRequirementsCreditFacility;
function mockGetFundingRequirementsCreditFacilitySuccess(stateKey, offerId, data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/funding_requirements/${stateKey}/credit_facility/${offerId}/`, "get", 200, data, options);
}
exports.mockGetFundingRequirementsCreditFacilitySuccess = mockGetFundingRequirementsCreditFacilitySuccess;
function mockGetFundingRequirementsCreditFacilityFailure(stateKey, offerId, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/funding_requirements/${stateKey}/credit_facility/${offerId}/`, "get", 400, failureResponse, options);
}
exports.mockGetFundingRequirementsCreditFacilityFailure = mockGetFundingRequirementsCreditFacilityFailure;
/**
 * To accurately return the
funding requirements that are checked on funding, all available
url parameters should be provided.

If not all url paramaters are provided, the system will
make a guess based on any offer configuration and other features
of the offer.

Parameters that are not available in the offer configuration
endpoint are unlikely to substantially affect funding parameters,
but it is still advisable to provide as complete information
as possible.

 */
function fetchGetFundingRequirementsFlexi24({ stateKey, offerId, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/funding_requirements/${stateKey}/flexi24/${offerId}/`, {
        method: "get",
        version: "edge",
    });
}
exports.fetchGetFundingRequirementsFlexi24 = fetchGetFundingRequirementsFlexi24;
function mockGetFundingRequirementsFlexi24Success(stateKey, offerId, data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/funding_requirements/${stateKey}/flexi24/${offerId}/`, "get", 200, data, options);
}
exports.mockGetFundingRequirementsFlexi24Success = mockGetFundingRequirementsFlexi24Success;
function mockGetFundingRequirementsFlexi24Failure(stateKey, offerId, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/funding_requirements/${stateKey}/flexi24/${offerId}/`, "get", 400, failureResponse, options);
}
exports.mockGetFundingRequirementsFlexi24Failure = mockGetFundingRequirementsFlexi24Failure;
/**
 * To accurately return the
funding requirements that are checked on funding, all available
url parameters should be provided.

If not all url paramaters are provided, the system will
make a guess based on any offer configuration and other features
of the offer.

Parameters that are not available in the offer configuration
endpoint are unlikely to substantially affect funding parameters,
but it is still advisable to provide as complete information
as possible.

 */
function fetchGetFundingRequirementsIwocapay({ stateKey, offerId, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/funding_requirements/${stateKey}/iwocapay/${offerId}/`, {
        method: "get",
        version: "edge",
    });
}
exports.fetchGetFundingRequirementsIwocapay = fetchGetFundingRequirementsIwocapay;
function mockGetFundingRequirementsIwocapaySuccess(stateKey, offerId, data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/funding_requirements/${stateKey}/iwocapay/${offerId}/`, "get", 200, data, options);
}
exports.mockGetFundingRequirementsIwocapaySuccess = mockGetFundingRequirementsIwocapaySuccess;
function mockGetFundingRequirementsIwocapayFailure(stateKey, offerId, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/funding_requirements/${stateKey}/iwocapay/${offerId}/`, "get", 400, failureResponse, options);
}
exports.mockGetFundingRequirementsIwocapayFailure = mockGetFundingRequirementsIwocapayFailure;
/**
 * To accurately return the
funding requirements that are checked on funding, all available
url parameters should be provided.

If not all url paramaters are provided, the system will
make a guess based on any offer configuration and other features
of the offer.

Parameters that are not available in the offer configuration
endpoint are unlikely to substantially affect funding parameters,
but it is still advisable to provide as complete information
as possible.

 */
function fetchGetFundingRequirementsMerchantCashAdvance({ stateKey, offerId, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/funding_requirements/${stateKey}/merchant_cash_advance/${offerId}/`, {
        method: "get",
        version: "edge",
    });
}
exports.fetchGetFundingRequirementsMerchantCashAdvance = fetchGetFundingRequirementsMerchantCashAdvance;
function mockGetFundingRequirementsMerchantCashAdvanceSuccess(stateKey, offerId, data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/funding_requirements/${stateKey}/merchant_cash_advance/${offerId}/`, "get", 200, data, options);
}
exports.mockGetFundingRequirementsMerchantCashAdvanceSuccess = mockGetFundingRequirementsMerchantCashAdvanceSuccess;
function mockGetFundingRequirementsMerchantCashAdvanceFailure(stateKey, offerId, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/funding_requirements/${stateKey}/merchant_cash_advance/${offerId}/`, "get", 400, failureResponse, options);
}
exports.mockGetFundingRequirementsMerchantCashAdvanceFailure = mockGetFundingRequirementsMerchantCashAdvanceFailure;
/**
 * To accurately return the
funding requirements that are checked on funding, all available
url parameters should be provided.

If not all url paramaters are provided, the system will
make a guess based on any offer configuration and other features
of the offer.

Parameters that are not available in the offer configuration
endpoint are unlikely to substantially affect funding parameters,
but it is still advisable to provide as complete information
as possible.

 */
function fetchGetFundingRequirementsRecoveryLoan({ stateKey, offerId, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/funding_requirements/${stateKey}/recovery_loan/${offerId}/`, {
        method: "get",
        version: "edge",
    });
}
exports.fetchGetFundingRequirementsRecoveryLoan = fetchGetFundingRequirementsRecoveryLoan;
function mockGetFundingRequirementsRecoveryLoanSuccess(stateKey, offerId, data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/funding_requirements/${stateKey}/recovery_loan/${offerId}/`, "get", 200, data, options);
}
exports.mockGetFundingRequirementsRecoveryLoanSuccess = mockGetFundingRequirementsRecoveryLoanSuccess;
function mockGetFundingRequirementsRecoveryLoanFailure(stateKey, offerId, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/funding_requirements/${stateKey}/recovery_loan/${offerId}/`, "get", 400, failureResponse, options);
}
exports.mockGetFundingRequirementsRecoveryLoanFailure = mockGetFundingRequirementsRecoveryLoanFailure;
/**
 * Create an introducer
 */
function fetchPostIntroducer({ body, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/introducer/`, {
        method: "post",
        version: "edge",
        body,
    });
}
exports.fetchPostIntroducer = fetchPostIntroducer;
function mockPostIntroducerSuccess(data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/introducer/`, "post", 201, data, options);
}
exports.mockPostIntroducerSuccess = mockPostIntroducerSuccess;
function mockPostIntroducerFailure(options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/introducer/`, "post", 400, failureResponse, options);
}
exports.mockPostIntroducerFailure = mockPostIntroducerFailure;
/**
 * Get the current introducer
 */
function fetchGetIntroducer({ introducerId }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/introducer/${introducerId}/`, {
        method: "get",
        version: "edge",
    });
}
exports.fetchGetIntroducer = fetchGetIntroducer;
function mockGetIntroducerSuccess(introducerId, data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/introducer/${introducerId}/`, "get", 200, data, options);
}
exports.mockGetIntroducerSuccess = mockGetIntroducerSuccess;
function mockGetIntroducerFailure(introducerId, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/introducer/${introducerId}/`, "get", 400, failureResponse, options);
}
exports.mockGetIntroducerFailure = mockGetIntroducerFailure;
/**
 * No description
 */
function fetchGetIntroducerApplication({ introducerId, applicationId, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/introducer/${introducerId}/application/${applicationId}/`, {
        method: "get",
        version: "edge",
    });
}
exports.fetchGetIntroducerApplication = fetchGetIntroducerApplication;
function mockGetIntroducerApplicationSuccess(introducerId, applicationId, data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/introducer/${introducerId}/application/${applicationId}/`, "get", 200, data, options);
}
exports.mockGetIntroducerApplicationSuccess = mockGetIntroducerApplicationSuccess;
function mockGetIntroducerApplicationFailure(introducerId, applicationId, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/introducer/${introducerId}/application/${applicationId}/`, "get", 400, failureResponse, options);
}
exports.mockGetIntroducerApplicationFailure = mockGetIntroducerApplicationFailure;
/**
 * No description
 */
function fetchGetIntroducerApplicationOfferAllowedWithdrawalFeeRates({ introducerId, applicationId, offerId, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/introducer/${introducerId}/application/${applicationId}/offer/${offerId}/allowed_withdrawal_fee_rates/`, {
        method: "get",
        version: "edge",
    });
}
exports.fetchGetIntroducerApplicationOfferAllowedWithdrawalFeeRates = fetchGetIntroducerApplicationOfferAllowedWithdrawalFeeRates;
function mockGetIntroducerApplicationOfferAllowedWithdrawalFeeRatesSuccess(introducerId, applicationId, offerId, data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/introducer/${introducerId}/application/${applicationId}/offer/${offerId}/allowed_withdrawal_fee_rates/`, "get", 200, data, options);
}
exports.mockGetIntroducerApplicationOfferAllowedWithdrawalFeeRatesSuccess = mockGetIntroducerApplicationOfferAllowedWithdrawalFeeRatesSuccess;
function mockGetIntroducerApplicationOfferAllowedWithdrawalFeeRatesFailure(introducerId, applicationId, offerId, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/introducer/${introducerId}/application/${applicationId}/offer/${offerId}/allowed_withdrawal_fee_rates/`, "get", 400, failureResponse, options);
}
exports.mockGetIntroducerApplicationOfferAllowedWithdrawalFeeRatesFailure = mockGetIntroducerApplicationOfferAllowedWithdrawalFeeRatesFailure;
/**
 * No description
 */
function fetchGetIntroducerApplicationOfferWithdrawalFeeRate({ introducerId, applicationId, offerId, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/introducer/${introducerId}/application/${applicationId}/offer/${offerId}/withdrawal_fee_rate/`, {
        method: "get",
        version: "edge",
    });
}
exports.fetchGetIntroducerApplicationOfferWithdrawalFeeRate = fetchGetIntroducerApplicationOfferWithdrawalFeeRate;
function mockGetIntroducerApplicationOfferWithdrawalFeeRateSuccess(introducerId, applicationId, offerId, data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/introducer/${introducerId}/application/${applicationId}/offer/${offerId}/withdrawal_fee_rate/`, "get", 200, data, options);
}
exports.mockGetIntroducerApplicationOfferWithdrawalFeeRateSuccess = mockGetIntroducerApplicationOfferWithdrawalFeeRateSuccess;
function mockGetIntroducerApplicationOfferWithdrawalFeeRateFailure(introducerId, applicationId, offerId, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/introducer/${introducerId}/application/${applicationId}/offer/${offerId}/withdrawal_fee_rate/`, "get", 400, failureResponse, options);
}
exports.mockGetIntroducerApplicationOfferWithdrawalFeeRateFailure = mockGetIntroducerApplicationOfferWithdrawalFeeRateFailure;
/**
 * No description
 */
function fetchPutIntroducerApplicationOfferWithdrawalFeeRate({ introducerId, applicationId, offerId, body, }) {
    return (0, lendingAPI_1.fetchLendingAPI)(`/introducer/${introducerId}/application/${applicationId}/offer/${offerId}/withdrawal_fee_rate/`, {
        method: "put",
        version: "edge",
        body,
    });
}
exports.fetchPutIntroducerApplicationOfferWithdrawalFeeRate = fetchPutIntroducerApplicationOfferWithdrawalFeeRate;
function mockPutIntroducerApplicationOfferWithdrawalFeeRateSuccess(introducerId, applicationId, offerId, data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/introducer/${introducerId}/application/${applicationId}/offer/${offerId}/withdrawal_fee_rate/`, "put", 202, data, options);
}
exports.mockPutIntroducerApplicationOfferWithdrawalFeeRateSuccess = mockPutIntroducerApplicationOfferWithdrawalFeeRateSuccess;
function mockPutIntroducerApplicationOfferWithdrawalFeeRateFailure(introducerId, applicationId, offerId, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/introducer/${introducerId}/application/${applicationId}/offer/${offerId}/withdrawal_fee_rate/`, "put", 400, failureResponse, options);
}
exports.mockPutIntroducerApplicationOfferWithdrawalFeeRateFailure = mockPutIntroducerApplicationOfferWithdrawalFeeRateFailure;
/**
 * No description
 */
function fetchGetIntroducerApplicationRejectOfferReasons({ introducerId, applicationId, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/introducer/${introducerId}/application/${applicationId}/reject_offer_reasons/`, {
        method: "get",
        version: "edge",
    });
}
exports.fetchGetIntroducerApplicationRejectOfferReasons = fetchGetIntroducerApplicationRejectOfferReasons;
function mockGetIntroducerApplicationRejectOfferReasonsSuccess(introducerId, applicationId, data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/introducer/${introducerId}/application/${applicationId}/reject_offer_reasons/`, "get", 200, data, options);
}
exports.mockGetIntroducerApplicationRejectOfferReasonsSuccess = mockGetIntroducerApplicationRejectOfferReasonsSuccess;
function mockGetIntroducerApplicationRejectOfferReasonsFailure(introducerId, applicationId, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/introducer/${introducerId}/application/${applicationId}/reject_offer_reasons/`, "get", 400, failureResponse, options);
}
exports.mockGetIntroducerApplicationRejectOfferReasonsFailure = mockGetIntroducerApplicationRejectOfferReasonsFailure;
/**
 * No description
 */
function fetchGetIntroducerApplications({ introducerId, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/introducer/${introducerId}/applications/`, {
        method: "get",
        version: "edge",
    });
}
exports.fetchGetIntroducerApplications = fetchGetIntroducerApplications;
function mockGetIntroducerApplicationsSuccess(introducerId, data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/introducer/${introducerId}/applications/`, "get", 200, data, options);
}
exports.mockGetIntroducerApplicationsSuccess = mockGetIntroducerApplicationsSuccess;
function mockGetIntroducerApplicationsFailure(introducerId, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/introducer/${introducerId}/applications/`, "get", 400, failureResponse, options);
}
exports.mockGetIntroducerApplicationsFailure = mockGetIntroducerApplicationsFailure;
/**
 * No description
 */
function fetchGetIntroducerContextByIntroducerId({ introducerId, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/introducer/${introducerId}/context/`, {
        method: "get",
        version: "edge",
    });
}
exports.fetchGetIntroducerContextByIntroducerId = fetchGetIntroducerContextByIntroducerId;
function mockGetIntroducerContextByIntroducerIdSuccess(introducerId, data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/introducer/${introducerId}/context/`, "get", 200, data, options);
}
exports.mockGetIntroducerContextByIntroducerIdSuccess = mockGetIntroducerContextByIntroducerIdSuccess;
function mockGetIntroducerContextByIntroducerIdFailure(introducerId, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/introducer/${introducerId}/context/`, "get", 400, failureResponse, options);
}
exports.mockGetIntroducerContextByIntroducerIdFailure = mockGetIntroducerContextByIntroducerIdFailure;
/**
 * No description
 */
function fetchGetIntroducerContext({}) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/introducer/context/`, {
        method: "get",
        version: "edge",
    });
}
exports.fetchGetIntroducerContext = fetchGetIntroducerContext;
function mockGetIntroducerContextSuccess(data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/introducer/context/`, "get", 200, data, options);
}
exports.mockGetIntroducerContextSuccess = mockGetIntroducerContextSuccess;
function mockGetIntroducerContextFailure(options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/introducer/context/`, "get", 400, failureResponse, options);
}
exports.mockGetIntroducerContextFailure = mockGetIntroducerContextFailure;
/**
 * Sends an email to an introducer&#x27;s customer to enable linking to open banking
 */
function fetchPostIntroducerLinkOpenBankingEmail({ introducerId, stateKey, body, }) {
    return (0, lendingAPI_1.fetchLendingAPI)(`/introducer/${introducerId}/link_open_banking_email/${stateKey}/`, {
        method: "post",
        version: "edge",
        body,
    });
}
exports.fetchPostIntroducerLinkOpenBankingEmail = fetchPostIntroducerLinkOpenBankingEmail;
function mockPostIntroducerLinkOpenBankingEmailSuccess(introducerId, stateKey, data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/introducer/${introducerId}/link_open_banking_email/${stateKey}/`, "post", 201, data, options);
}
exports.mockPostIntroducerLinkOpenBankingEmailSuccess = mockPostIntroducerLinkOpenBankingEmailSuccess;
function mockPostIntroducerLinkOpenBankingEmailFailure(introducerId, stateKey, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/introducer/${introducerId}/link_open_banking_email/${stateKey}/`, "post", 400, failureResponse, options);
}
exports.mockPostIntroducerLinkOpenBankingEmailFailure = mockPostIntroducerLinkOpenBankingEmailFailure;
/**
 * Updates the entity_to_contact for formal_offers for an introducer
 */
function fetchPutIntroducerUpdateFormalOfferEntityToContact({ introducerId, body, }) {
    return (0, lendingAPI_1.fetchLendingAPI)(`/introducer/${introducerId}/update_formal_offer_entity_to_contact/`, {
        method: "put",
        version: "edge",
        body,
    });
}
exports.fetchPutIntroducerUpdateFormalOfferEntityToContact = fetchPutIntroducerUpdateFormalOfferEntityToContact;
function mockPutIntroducerUpdateFormalOfferEntityToContactSuccess(introducerId, data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/introducer/${introducerId}/update_formal_offer_entity_to_contact/`, "put", 202, data, options);
}
exports.mockPutIntroducerUpdateFormalOfferEntityToContactSuccess = mockPutIntroducerUpdateFormalOfferEntityToContactSuccess;
function mockPutIntroducerUpdateFormalOfferEntityToContactFailure(introducerId, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/introducer/${introducerId}/update_formal_offer_entity_to_contact/`, "put", 400, failureResponse, options);
}
exports.mockPutIntroducerUpdateFormalOfferEntityToContactFailure = mockPutIntroducerUpdateFormalOfferEntityToContactFailure;
/**
 * No description
 */
function fetchGetIwocapayBuyerPayLinkPackage({ payLinkPackageId, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/iwocapay/buyer/pay_link_package/${payLinkPackageId}/`, {
        method: "get",
        version: "edge",
    });
}
exports.fetchGetIwocapayBuyerPayLinkPackage = fetchGetIwocapayBuyerPayLinkPackage;
function mockGetIwocapayBuyerPayLinkPackageSuccess(payLinkPackageId, data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/iwocapay/buyer/pay_link_package/${payLinkPackageId}/`, "get", 200, data, options);
}
exports.mockGetIwocapayBuyerPayLinkPackageSuccess = mockGetIwocapayBuyerPayLinkPackageSuccess;
function mockGetIwocapayBuyerPayLinkPackageFailure(payLinkPackageId, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/iwocapay/buyer/pay_link_package/${payLinkPackageId}/`, "get", 400, failureResponse, options);
}
exports.mockGetIwocapayBuyerPayLinkPackageFailure = mockGetIwocapayBuyerPayLinkPackageFailure;
/**
 * No description
 */
function fetchPostIwocapayNotifications({ body, }) {
    return (0, lendingAPI_1.fetchLendingAPI)(`/iwocapay/notifications/`, {
        method: "post",
        version: "edge",
        body,
    });
}
exports.fetchPostIwocapayNotifications = fetchPostIwocapayNotifications;
function mockPostIwocapayNotificationsSuccess(data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/iwocapay/notifications/`, "post", 202, data, options);
}
exports.mockPostIwocapayNotificationsSuccess = mockPostIwocapayNotificationsSuccess;
function mockPostIwocapayNotificationsFailure(options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/iwocapay/notifications/`, "post", 400, failureResponse, options);
}
exports.mockPostIwocapayNotificationsFailure = mockPostIwocapayNotificationsFailure;
/**
 * No description
 */
function fetchGetIwocapayPayLinkPackage({ stateKey, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/iwocapay/pay_link_package/${stateKey}/`, {
        method: "get",
        version: "edge",
    });
}
exports.fetchGetIwocapayPayLinkPackage = fetchGetIwocapayPayLinkPackage;
function mockGetIwocapayPayLinkPackageSuccess(stateKey, data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/iwocapay/pay_link_package/${stateKey}/`, "get", 200, data, options);
}
exports.mockGetIwocapayPayLinkPackageSuccess = mockGetIwocapayPayLinkPackageSuccess;
function mockGetIwocapayPayLinkPackageFailure(stateKey, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/iwocapay/pay_link_package/${stateKey}/`, "get", 400, failureResponse, options);
}
exports.mockGetIwocapayPayLinkPackageFailure = mockGetIwocapayPayLinkPackageFailure;
/**
 * No description
 */
function fetchPostIwocapayPayLinkPackage({ stateKey, body, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/iwocapay/pay_link_package/${stateKey}/`, {
        method: "post",
        version: "edge",
        body,
    });
}
exports.fetchPostIwocapayPayLinkPackage = fetchPostIwocapayPayLinkPackage;
function mockPostIwocapayPayLinkPackageSuccess(stateKey, data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/iwocapay/pay_link_package/${stateKey}/`, "post", 201, data, options);
}
exports.mockPostIwocapayPayLinkPackageSuccess = mockPostIwocapayPayLinkPackageSuccess;
function mockPostIwocapayPayLinkPackageFailure(stateKey, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/iwocapay/pay_link_package/${stateKey}/`, "post", 400, failureResponse, options);
}
exports.mockPostIwocapayPayLinkPackageFailure = mockPostIwocapayPayLinkPackageFailure;
/**
 * No description
 */
function fetchGetIwocapayPaymentLater({ stateKey, }) {
    return (0, lendingAPI_1.fetchLendingAPI)(`/iwocapay/payment/later/${stateKey}/`, {
        method: "get",
        version: "edge",
    });
}
exports.fetchGetIwocapayPaymentLater = fetchGetIwocapayPaymentLater;
function mockGetIwocapayPaymentLaterSuccess(stateKey, data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/iwocapay/payment/later/${stateKey}/`, "get", 200, data, options);
}
exports.mockGetIwocapayPaymentLaterSuccess = mockGetIwocapayPaymentLaterSuccess;
function mockGetIwocapayPaymentLaterFailure(stateKey, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/iwocapay/payment/later/${stateKey}/`, "get", 400, failureResponse, options);
}
exports.mockGetIwocapayPaymentLaterFailure = mockGetIwocapayPaymentLaterFailure;
/**
 * No description
 */
function fetchPostIwocapayPaymentLater({ stateKey, body, }) {
    return (0, lendingAPI_1.fetchLendingAPI)(`/iwocapay/payment/later/${stateKey}/`, {
        method: "post",
        version: "edge",
        body,
    });
}
exports.fetchPostIwocapayPaymentLater = fetchPostIwocapayPaymentLater;
function mockPostIwocapayPaymentLaterSuccess(stateKey, data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/iwocapay/payment/later/${stateKey}/`, "post", 201, data, options);
}
exports.mockPostIwocapayPaymentLaterSuccess = mockPostIwocapayPaymentLaterSuccess;
function mockPostIwocapayPaymentLaterFailure(stateKey, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/iwocapay/payment/later/${stateKey}/`, "post", 400, failureResponse, options);
}
exports.mockPostIwocapayPaymentLaterFailure = mockPostIwocapayPaymentLaterFailure;
/**
 * No description
 */
function fetchPostIwocapayPaymentNow({ sellerHandle, body, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/iwocapay/payment/now/${sellerHandle}/`, {
        method: "post",
        version: "edge",
        body,
    });
}
exports.fetchPostIwocapayPaymentNow = fetchPostIwocapayPaymentNow;
function mockPostIwocapayPaymentNowSuccess(sellerHandle, data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/iwocapay/payment/now/${sellerHandle}/`, "post", 201, data, options);
}
exports.mockPostIwocapayPaymentNowSuccess = mockPostIwocapayPaymentNowSuccess;
function mockPostIwocapayPaymentNowFailure(sellerHandle, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/iwocapay/payment/now/${sellerHandle}/`, "post", 400, failureResponse, options);
}
exports.mockPostIwocapayPaymentNowFailure = mockPostIwocapayPaymentNowFailure;
/**
 * No description
 */
function fetchGetIwocapayReferral({ stateKey }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/iwocapay/referral/${stateKey}/`, {
        method: "get",
        version: "edge",
    });
}
exports.fetchGetIwocapayReferral = fetchGetIwocapayReferral;
function mockGetIwocapayReferralSuccess(stateKey, data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/iwocapay/referral/${stateKey}/`, "get", 200, data, options);
}
exports.mockGetIwocapayReferralSuccess = mockGetIwocapayReferralSuccess;
function mockGetIwocapayReferralFailure(stateKey, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/iwocapay/referral/${stateKey}/`, "get", 400, failureResponse, options);
}
exports.mockGetIwocapayReferralFailure = mockGetIwocapayReferralFailure;
/**
 * No description
 */
function fetchGetIwocapayReferrals({ stateKey }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/iwocapay/referrals/${stateKey}/`, {
        method: "get",
        version: "edge",
    });
}
exports.fetchGetIwocapayReferrals = fetchGetIwocapayReferrals;
function mockGetIwocapayReferralsSuccess(stateKey, data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/iwocapay/referrals/${stateKey}/`, "get", 200, data, options);
}
exports.mockGetIwocapayReferralsSuccess = mockGetIwocapayReferralsSuccess;
function mockGetIwocapayReferralsFailure(stateKey, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/iwocapay/referrals/${stateKey}/`, "get", 400, failureResponse, options);
}
exports.mockGetIwocapayReferralsFailure = mockGetIwocapayReferralsFailure;
/**
 * No description
 */
function fetchGetIwocapayReferrer({ referralCode, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/iwocapay/referrer/${referralCode}/`, {
        method: "get",
        version: "edge",
    });
}
exports.fetchGetIwocapayReferrer = fetchGetIwocapayReferrer;
function mockGetIwocapayReferrerSuccess(referralCode, data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/iwocapay/referrer/${referralCode}/`, "get", 200, data, options);
}
exports.mockGetIwocapayReferrerSuccess = mockGetIwocapayReferrerSuccess;
function mockGetIwocapayReferrerFailure(referralCode, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/iwocapay/referrer/${referralCode}/`, "get", 400, failureResponse, options);
}
exports.mockGetIwocapayReferrerFailure = mockGetIwocapayReferrerFailure;
/**
 * No description
 */
function fetchGetIwocapaySellerOnboardingAnswers({ stateKey, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/iwocapay/seller_onboarding_answers/${stateKey}/`, {
        method: "get",
        version: "edge",
    });
}
exports.fetchGetIwocapaySellerOnboardingAnswers = fetchGetIwocapaySellerOnboardingAnswers;
function mockGetIwocapaySellerOnboardingAnswersSuccess(stateKey, data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/iwocapay/seller_onboarding_answers/${stateKey}/`, "get", 200, data, options);
}
exports.mockGetIwocapaySellerOnboardingAnswersSuccess = mockGetIwocapaySellerOnboardingAnswersSuccess;
function mockGetIwocapaySellerOnboardingAnswersFailure(stateKey, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/iwocapay/seller_onboarding_answers/${stateKey}/`, "get", 400, failureResponse, options);
}
exports.mockGetIwocapaySellerOnboardingAnswersFailure = mockGetIwocapaySellerOnboardingAnswersFailure;
/**
 * No description
 */
function fetchPostIwocapaySellerOnboardingAnswers({ stateKey, body, }) {
    return (0, lendingAPI_1.fetchLendingAPI)(`/iwocapay/seller_onboarding_answers/${stateKey}/`, {
        method: "post",
        version: "edge",
        body,
    });
}
exports.fetchPostIwocapaySellerOnboardingAnswers = fetchPostIwocapaySellerOnboardingAnswers;
function mockPostIwocapaySellerOnboardingAnswersSuccess(stateKey, data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/iwocapay/seller_onboarding_answers/${stateKey}/`, "post", 201, data, options);
}
exports.mockPostIwocapaySellerOnboardingAnswersSuccess = mockPostIwocapaySellerOnboardingAnswersSuccess;
function mockPostIwocapaySellerOnboardingAnswersFailure(stateKey, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/iwocapay/seller_onboarding_answers/${stateKey}/`, "post", 400, failureResponse, options);
}
exports.mockPostIwocapaySellerOnboardingAnswersFailure = mockPostIwocapaySellerOnboardingAnswersFailure;
/**
 * Returns details of documents that must be signed before drawdown

To ensure the documents have the correct information, it may be necessary
to specify additional url parameters depending on the product.
If not all url paramaters are provided, the system will
make a guess based on any offer configuration and other features
of the offer.

Parameters that are not available in the offer configuration
endpoint are unlikely to substantially affect funding parameters,
but it is still advisable to provide as complete information
as possible.

 */
function fetchGetLoanDocumentsRequiredBusinessLoan({ stateKey, offerId, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/loan_documents/${stateKey}/required/business_loan/${offerId}/`, {
        method: "get",
        version: "edge",
    });
}
exports.fetchGetLoanDocumentsRequiredBusinessLoan = fetchGetLoanDocumentsRequiredBusinessLoan;
function mockGetLoanDocumentsRequiredBusinessLoanSuccess(stateKey, offerId, data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/loan_documents/${stateKey}/required/business_loan/${offerId}/`, "get", 200, data, options);
}
exports.mockGetLoanDocumentsRequiredBusinessLoanSuccess = mockGetLoanDocumentsRequiredBusinessLoanSuccess;
function mockGetLoanDocumentsRequiredBusinessLoanFailure(stateKey, offerId, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/loan_documents/${stateKey}/required/business_loan/${offerId}/`, "get", 400, failureResponse, options);
}
exports.mockGetLoanDocumentsRequiredBusinessLoanFailure = mockGetLoanDocumentsRequiredBusinessLoanFailure;
/**
 * Returns details of documents that must be signed before drawdown

To ensure the documents have the correct information, it may be necessary
to specify additional url parameters depending on the product.
If not all url paramaters are provided, the system will
make a guess based on any offer configuration and other features
of the offer.

Parameters that are not available in the offer configuration
endpoint are unlikely to substantially affect funding parameters,
but it is still advisable to provide as complete information
as possible.

 */
function fetchGetLoanDocumentsRequiredCbils({ stateKey, offerId, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/loan_documents/${stateKey}/required/cbils/${offerId}/`, {
        method: "get",
        version: "edge",
    });
}
exports.fetchGetLoanDocumentsRequiredCbils = fetchGetLoanDocumentsRequiredCbils;
function mockGetLoanDocumentsRequiredCbilsSuccess(stateKey, offerId, data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/loan_documents/${stateKey}/required/cbils/${offerId}/`, "get", 200, data, options);
}
exports.mockGetLoanDocumentsRequiredCbilsSuccess = mockGetLoanDocumentsRequiredCbilsSuccess;
function mockGetLoanDocumentsRequiredCbilsFailure(stateKey, offerId, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/loan_documents/${stateKey}/required/cbils/${offerId}/`, "get", 400, failureResponse, options);
}
exports.mockGetLoanDocumentsRequiredCbilsFailure = mockGetLoanDocumentsRequiredCbilsFailure;
/**
 * Returns details of documents that must be signed before drawdown

To ensure the documents have the correct information, it may be necessary
to specify additional url parameters depending on the product.
If not all url paramaters are provided, the system will
make a guess based on any offer configuration and other features
of the offer.

Parameters that are not available in the offer configuration
endpoint are unlikely to substantially affect funding parameters,
but it is still advisable to provide as complete information
as possible.

 */
function fetchGetLoanDocumentsRequiredCreditFacility({ stateKey, offerId, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/loan_documents/${stateKey}/required/credit_facility/${offerId}/`, {
        method: "get",
        version: "edge",
    });
}
exports.fetchGetLoanDocumentsRequiredCreditFacility = fetchGetLoanDocumentsRequiredCreditFacility;
function mockGetLoanDocumentsRequiredCreditFacilitySuccess(stateKey, offerId, data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/loan_documents/${stateKey}/required/credit_facility/${offerId}/`, "get", 200, data, options);
}
exports.mockGetLoanDocumentsRequiredCreditFacilitySuccess = mockGetLoanDocumentsRequiredCreditFacilitySuccess;
function mockGetLoanDocumentsRequiredCreditFacilityFailure(stateKey, offerId, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/loan_documents/${stateKey}/required/credit_facility/${offerId}/`, "get", 400, failureResponse, options);
}
exports.mockGetLoanDocumentsRequiredCreditFacilityFailure = mockGetLoanDocumentsRequiredCreditFacilityFailure;
/**
 * Returns details of documents that must be signed before drawdown

To ensure the documents have the correct information, it may be necessary
to specify additional url parameters depending on the product.
If not all url paramaters are provided, the system will
make a guess based on any offer configuration and other features
of the offer.

Parameters that are not available in the offer configuration
endpoint are unlikely to substantially affect funding parameters,
but it is still advisable to provide as complete information
as possible.

 */
function fetchGetLoanDocumentsRequiredFlexi24({ stateKey, offerId, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/loan_documents/${stateKey}/required/flexi24/${offerId}/`, {
        method: "get",
        version: "edge",
    });
}
exports.fetchGetLoanDocumentsRequiredFlexi24 = fetchGetLoanDocumentsRequiredFlexi24;
function mockGetLoanDocumentsRequiredFlexi24Success(stateKey, offerId, data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/loan_documents/${stateKey}/required/flexi24/${offerId}/`, "get", 200, data, options);
}
exports.mockGetLoanDocumentsRequiredFlexi24Success = mockGetLoanDocumentsRequiredFlexi24Success;
function mockGetLoanDocumentsRequiredFlexi24Failure(stateKey, offerId, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/loan_documents/${stateKey}/required/flexi24/${offerId}/`, "get", 400, failureResponse, options);
}
exports.mockGetLoanDocumentsRequiredFlexi24Failure = mockGetLoanDocumentsRequiredFlexi24Failure;
/**
 * Returns details of documents that must be signed before drawdown

To ensure the documents have the correct information, it may be necessary
to specify additional url parameters depending on the product.
If not all url paramaters are provided, the system will
make a guess based on any offer configuration and other features
of the offer.

Parameters that are not available in the offer configuration
endpoint are unlikely to substantially affect funding parameters,
but it is still advisable to provide as complete information
as possible.

 */
function fetchGetLoanDocumentsRequiredIwocapay({ stateKey, offerId, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/loan_documents/${stateKey}/required/iwocapay/${offerId}/`, {
        method: "get",
        version: "edge",
    });
}
exports.fetchGetLoanDocumentsRequiredIwocapay = fetchGetLoanDocumentsRequiredIwocapay;
function mockGetLoanDocumentsRequiredIwocapaySuccess(stateKey, offerId, data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/loan_documents/${stateKey}/required/iwocapay/${offerId}/`, "get", 200, data, options);
}
exports.mockGetLoanDocumentsRequiredIwocapaySuccess = mockGetLoanDocumentsRequiredIwocapaySuccess;
function mockGetLoanDocumentsRequiredIwocapayFailure(stateKey, offerId, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/loan_documents/${stateKey}/required/iwocapay/${offerId}/`, "get", 400, failureResponse, options);
}
exports.mockGetLoanDocumentsRequiredIwocapayFailure = mockGetLoanDocumentsRequiredIwocapayFailure;
/**
 * Returns details of documents that must be signed before drawdown

To ensure the documents have the correct information, it may be necessary
to specify additional url parameters depending on the product.
If not all url paramaters are provided, the system will
make a guess based on any offer configuration and other features
of the offer.

Parameters that are not available in the offer configuration
endpoint are unlikely to substantially affect funding parameters,
but it is still advisable to provide as complete information
as possible.

 */
function fetchGetLoanDocumentsRequiredMerchantCashAdvance({ stateKey, offerId, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/loan_documents/${stateKey}/required/merchant_cash_advance/${offerId}/`, {
        method: "get",
        version: "edge",
    });
}
exports.fetchGetLoanDocumentsRequiredMerchantCashAdvance = fetchGetLoanDocumentsRequiredMerchantCashAdvance;
function mockGetLoanDocumentsRequiredMerchantCashAdvanceSuccess(stateKey, offerId, data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/loan_documents/${stateKey}/required/merchant_cash_advance/${offerId}/`, "get", 200, data, options);
}
exports.mockGetLoanDocumentsRequiredMerchantCashAdvanceSuccess = mockGetLoanDocumentsRequiredMerchantCashAdvanceSuccess;
function mockGetLoanDocumentsRequiredMerchantCashAdvanceFailure(stateKey, offerId, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/loan_documents/${stateKey}/required/merchant_cash_advance/${offerId}/`, "get", 400, failureResponse, options);
}
exports.mockGetLoanDocumentsRequiredMerchantCashAdvanceFailure = mockGetLoanDocumentsRequiredMerchantCashAdvanceFailure;
/**
 * Returns details of documents that must be signed before drawdown

To ensure the documents have the correct information, it may be necessary
to specify additional url parameters depending on the product.
If not all url paramaters are provided, the system will
make a guess based on any offer configuration and other features
of the offer.

Parameters that are not available in the offer configuration
endpoint are unlikely to substantially affect funding parameters,
but it is still advisable to provide as complete information
as possible.

 */
function fetchGetLoanDocumentsRequiredRecoveryLoan({ stateKey, offerId, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/loan_documents/${stateKey}/required/recovery_loan/${offerId}/`, {
        method: "get",
        version: "edge",
    });
}
exports.fetchGetLoanDocumentsRequiredRecoveryLoan = fetchGetLoanDocumentsRequiredRecoveryLoan;
function mockGetLoanDocumentsRequiredRecoveryLoanSuccess(stateKey, offerId, data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/loan_documents/${stateKey}/required/recovery_loan/${offerId}/`, "get", 200, data, options);
}
exports.mockGetLoanDocumentsRequiredRecoveryLoanSuccess = mockGetLoanDocumentsRequiredRecoveryLoanSuccess;
function mockGetLoanDocumentsRequiredRecoveryLoanFailure(stateKey, offerId, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/loan_documents/${stateKey}/required/recovery_loan/${offerId}/`, "get", 400, failureResponse, options);
}
exports.mockGetLoanDocumentsRequiredRecoveryLoanFailure = mockGetLoanDocumentsRequiredRecoveryLoanFailure;
/**
 * No description
 */
function fetchPostLoanDocumentsSigned({ stateKey, body, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/loan_documents/${stateKey}/signed/`, {
        method: "post",
        version: "edge",
        body,
    });
}
exports.fetchPostLoanDocumentsSigned = fetchPostLoanDocumentsSigned;
function mockPostLoanDocumentsSignedSuccess(stateKey, data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/loan_documents/${stateKey}/signed/`, "post", 201, data, options);
}
exports.mockPostLoanDocumentsSignedSuccess = mockPostLoanDocumentsSignedSuccess;
function mockPostLoanDocumentsSignedFailure(stateKey, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/loan_documents/${stateKey}/signed/`, "post", 400, failureResponse, options);
}
exports.mockPostLoanDocumentsSignedFailure = mockPostLoanDocumentsSignedFailure;
/**
 * No description
 */
function fetchGetLoanDocumentsSigned({ stateKey, documentId, query, }) {
    return (0, lendingAPI_1.fetchLendingAPI)(`/loan_documents/${stateKey}/signed/${documentId}/`, {
        method: "get",
        version: "edge",
        query,
    });
}
exports.fetchGetLoanDocumentsSigned = fetchGetLoanDocumentsSigned;
function mockGetLoanDocumentsSignedSuccess(stateKey, documentId, data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/loan_documents/${stateKey}/signed/${documentId}/`, "get", 200, data, options);
}
exports.mockGetLoanDocumentsSignedSuccess = mockGetLoanDocumentsSignedSuccess;
function mockGetLoanDocumentsSignedFailure(stateKey, documentId, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/loan_documents/${stateKey}/signed/${documentId}/`, "get", 400, failureResponse, options);
}
exports.mockGetLoanDocumentsSignedFailure = mockGetLoanDocumentsSignedFailure;
/**
 * No description
 */
function fetchGetLoanDocumentsUnsigned({ stateKey, documentId, query, }) {
    return (0, lendingAPI_1.fetchLendingAPI)(`/loan_documents/${stateKey}/unsigned/${documentId}/`, {
        method: "get",
        version: "edge",
        query,
    });
}
exports.fetchGetLoanDocumentsUnsigned = fetchGetLoanDocumentsUnsigned;
function mockGetLoanDocumentsUnsignedSuccess(stateKey, documentId, data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/loan_documents/${stateKey}/unsigned/${documentId}/`, "get", 200, data, options);
}
exports.mockGetLoanDocumentsUnsignedSuccess = mockGetLoanDocumentsUnsignedSuccess;
function mockGetLoanDocumentsUnsignedFailure(stateKey, documentId, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/loan_documents/${stateKey}/unsigned/${documentId}/`, "get", 400, failureResponse, options);
}
exports.mockGetLoanDocumentsUnsignedFailure = mockGetLoanDocumentsUnsignedFailure;
/**
 * No description
 */
function fetchGetLoginLink({ stateKey }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/login_link/${stateKey}/`, {
        method: "get",
        version: "edge",
    });
}
exports.fetchGetLoginLink = fetchGetLoginLink;
function mockGetLoginLinkSuccess(stateKey, data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/login_link/${stateKey}/`, "get", 200, data, options);
}
exports.mockGetLoginLinkSuccess = mockGetLoginLinkSuccess;
function mockGetLoginLinkFailure(stateKey, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/login_link/${stateKey}/`, "get", 400, failureResponse, options);
}
exports.mockGetLoginLinkFailure = mockGetLoginLinkFailure;
/**
 * No description
 */
function fetchPostLogout({ body }) {
    return (0, lendingAPI_1.fetchLendingAPI)(`/logout/`, {
        method: "post",
        version: "edge",
        body,
    });
}
exports.fetchPostLogout = fetchPostLogout;
function mockPostLogoutSuccess(data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/logout/`, "post", 204, data, options);
}
exports.mockPostLogoutSuccess = mockPostLogoutSuccess;
function mockPostLogoutFailure(options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/logout/`, "post", 400, failureResponse, options);
}
exports.mockPostLogoutFailure = mockPostLogoutFailure;
/**
 * Returning the merchant cash advance estimated schedule for a customer. Allows to estimate a schedule providing different amounts and sweep fractions.
 */
function fetchGetMcaEstimatedSchedule({ stateKey, offerId, query, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/mca_estimated_schedule/${stateKey}/${offerId}/`, {
        method: "get",
        version: "edge",
        query,
    });
}
exports.fetchGetMcaEstimatedSchedule = fetchGetMcaEstimatedSchedule;
function mockGetMcaEstimatedScheduleSuccess(stateKey, offerId, data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/mca_estimated_schedule/${stateKey}/${offerId}/`, "get", 200, data, options);
}
exports.mockGetMcaEstimatedScheduleSuccess = mockGetMcaEstimatedScheduleSuccess;
function mockGetMcaEstimatedScheduleFailure(stateKey, offerId, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/mca_estimated_schedule/${stateKey}/${offerId}/`, "get", 400, failureResponse, options);
}
exports.mockGetMcaEstimatedScheduleFailure = mockGetMcaEstimatedScheduleFailure;
/**
 * No description
 */
function fetchGetOnfidoCheck({ stateKey, personUid, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/onfido/check/${stateKey}/${personUid}/`, {
        method: "get",
        version: "edge",
    });
}
exports.fetchGetOnfidoCheck = fetchGetOnfidoCheck;
function mockGetOnfidoCheckSuccess(stateKey, personUid, data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/onfido/check/${stateKey}/${personUid}/`, "get", 200, data, options);
}
exports.mockGetOnfidoCheckSuccess = mockGetOnfidoCheckSuccess;
function mockGetOnfidoCheckFailure(stateKey, personUid, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/onfido/check/${stateKey}/${personUid}/`, "get", 400, failureResponse, options);
}
exports.mockGetOnfidoCheckFailure = mockGetOnfidoCheckFailure;
/**
 * No description
 */
function fetchPostOnfidoChecks({ body, }) {
    return (0, lendingAPI_1.fetchLendingAPI)(`/onfido/checks/`, {
        method: "post",
        version: "edge",
        body,
    });
}
exports.fetchPostOnfidoChecks = fetchPostOnfidoChecks;
function mockPostOnfidoChecksSuccess(data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/onfido/checks/`, "post", 201, data, options);
}
exports.mockPostOnfidoChecksSuccess = mockPostOnfidoChecksSuccess;
function mockPostOnfidoChecksFailure(options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/onfido/checks/`, "post", 400, failureResponse, options);
}
exports.mockPostOnfidoChecksFailure = mockPostOnfidoChecksFailure;
/**
 * No description
 */
function fetchPostOnfidoStart({ stateKey, body, }) {
    return (0, lendingAPI_1.fetchLendingAPI)(`/onfido/start/${stateKey}/`, {
        method: "post",
        version: "edge",
        body,
    });
}
exports.fetchPostOnfidoStart = fetchPostOnfidoStart;
function mockPostOnfidoStartSuccess(stateKey, data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/onfido/start/${stateKey}/`, "post", 201, data, options);
}
exports.mockPostOnfidoStartSuccess = mockPostOnfidoStartSuccess;
function mockPostOnfidoStartFailure(stateKey, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/onfido/start/${stateKey}/`, "post", 400, failureResponse, options);
}
exports.mockPostOnfidoStartFailure = mockPostOnfidoStartFailure;
/**
 * No description
 */
function fetchPostOnfidoToken({ body, }) {
    return (0, lendingAPI_1.fetchLendingAPI)(`/onfido/token/`, {
        method: "post",
        version: "edge",
        body,
    });
}
exports.fetchPostOnfidoToken = fetchPostOnfidoToken;
function mockPostOnfidoTokenSuccess(data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/onfido/token/`, "post", 201, data, options);
}
exports.mockPostOnfidoTokenSuccess = mockPostOnfidoTokenSuccess;
function mockPostOnfidoTokenFailure(options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/onfido/token/`, "post", 400, failureResponse, options);
}
exports.mockPostOnfidoTokenFailure = mockPostOnfidoTokenFailure;
/**
 * No description
 */
function fetchGetOnlineAccount({ stateKey }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/online_account/${stateKey}/`, {
        method: "get",
        version: "edge",
    });
}
exports.fetchGetOnlineAccount = fetchGetOnlineAccount;
function mockGetOnlineAccountSuccess(stateKey, data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/online_account/${stateKey}/`, "get", 200, data, options);
}
exports.mockGetOnlineAccountSuccess = mockGetOnlineAccountSuccess;
function mockGetOnlineAccountFailure(stateKey, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/online_account/${stateKey}/`, "get", 400, failureResponse, options);
}
exports.mockGetOnlineAccountFailure = mockGetOnlineAccountFailure;
/**
 * Get information about outstanding CBILS or BBL loans for a given customer.
 */
function fetchGetOutstandingCbilsOrBbl({ stateKey, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/outstanding_cbils_or_bbl/${stateKey}/`, {
        method: "get",
        version: "edge",
    });
}
exports.fetchGetOutstandingCbilsOrBbl = fetchGetOutstandingCbilsOrBbl;
function mockGetOutstandingCbilsOrBblSuccess(stateKey, data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/outstanding_cbils_or_bbl/${stateKey}/`, "get", 200, data, options);
}
exports.mockGetOutstandingCbilsOrBblSuccess = mockGetOutstandingCbilsOrBblSuccess;
function mockGetOutstandingCbilsOrBblFailure(stateKey, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/outstanding_cbils_or_bbl/${stateKey}/`, "get", 400, failureResponse, options);
}
exports.mockGetOutstandingCbilsOrBblFailure = mockGetOutstandingCbilsOrBblFailure;
/**
 * Submit information about outstanding CBILS or BBL loans for a given customer.
 */
function fetchPostOutstandingCbilsOrBbl({ stateKey, body, }) {
    return (0, lendingAPI_1.fetchLendingAPI)(`/outstanding_cbils_or_bbl/${stateKey}/`, {
        method: "post",
        version: "edge",
        body,
    });
}
exports.fetchPostOutstandingCbilsOrBbl = fetchPostOutstandingCbilsOrBbl;
function mockPostOutstandingCbilsOrBblSuccess(stateKey, data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/outstanding_cbils_or_bbl/${stateKey}/`, "post", 201, data, options);
}
exports.mockPostOutstandingCbilsOrBblSuccess = mockPostOutstandingCbilsOrBblSuccess;
function mockPostOutstandingCbilsOrBblFailure(stateKey, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/outstanding_cbils_or_bbl/${stateKey}/`, "post", 400, failureResponse, options);
}
exports.mockPostOutstandingCbilsOrBblFailure = mockPostOutstandingCbilsOrBblFailure;
/**
 * Get information about loans outstanding for a customer on Government Schemes
 */
function fetchGetOutstandingGovernmentSchemeLoans({ stateKey, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/outstanding_government_scheme_loans/${stateKey}/`, {
        method: "get",
        version: "edge",
    });
}
exports.fetchGetOutstandingGovernmentSchemeLoans = fetchGetOutstandingGovernmentSchemeLoans;
function mockGetOutstandingGovernmentSchemeLoansSuccess(stateKey, data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/outstanding_government_scheme_loans/${stateKey}/`, "get", 200, data, options);
}
exports.mockGetOutstandingGovernmentSchemeLoansSuccess = mockGetOutstandingGovernmentSchemeLoansSuccess;
function mockGetOutstandingGovernmentSchemeLoansFailure(stateKey, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/outstanding_government_scheme_loans/${stateKey}/`, "get", 400, failureResponse, options);
}
exports.mockGetOutstandingGovernmentSchemeLoansFailure = mockGetOutstandingGovernmentSchemeLoansFailure;
/**
 * Submit information about outstanding Government Scheme Loans for a customer.
 */
function fetchPutOutstandingGovernmentSchemeLoans({ stateKey, body, }) {
    return (0, lendingAPI_1.fetchLendingAPI)(`/outstanding_government_scheme_loans/${stateKey}/`, {
        method: "put",
        version: "edge",
        body,
    });
}
exports.fetchPutOutstandingGovernmentSchemeLoans = fetchPutOutstandingGovernmentSchemeLoans;
function mockPutOutstandingGovernmentSchemeLoansSuccess(stateKey, data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/outstanding_government_scheme_loans/${stateKey}/`, "put", 202, data, options);
}
exports.mockPutOutstandingGovernmentSchemeLoansSuccess = mockPutOutstandingGovernmentSchemeLoansSuccess;
function mockPutOutstandingGovernmentSchemeLoansFailure(stateKey, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/outstanding_government_scheme_loans/${stateKey}/`, "put", 400, failureResponse, options);
}
exports.mockPutOutstandingGovernmentSchemeLoansFailure = mockPutOutstandingGovernmentSchemeLoansFailure;
/**
 * Returns a list of all brokers, including default one, associated with a partner
 */
function fetchGetPartnerBrokers({}) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/partner_brokers/`, {
        method: "get",
        version: "edge",
    });
}
exports.fetchGetPartnerBrokers = fetchGetPartnerBrokers;
function mockGetPartnerBrokersSuccess(data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/partner_brokers/`, "get", 200, data, options);
}
exports.mockGetPartnerBrokersSuccess = mockGetPartnerBrokersSuccess;
function mockGetPartnerBrokersFailure(options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/partner_brokers/`, "get", 400, failureResponse, options);
}
exports.mockGetPartnerBrokersFailure = mockGetPartnerBrokersFailure;
/**
 * Create a partner developer
 */
function fetchPostPartnerDeveloper({ body, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/partner_developer/`, {
        method: "post",
        version: "edge",
        body,
    });
}
exports.fetchPostPartnerDeveloper = fetchPostPartnerDeveloper;
function mockPostPartnerDeveloperSuccess(data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/partner_developer/`, "post", 201, data, options);
}
exports.mockPostPartnerDeveloperSuccess = mockPostPartnerDeveloperSuccess;
function mockPostPartnerDeveloperFailure(options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/partner_developer/`, "post", 400, failureResponse, options);
}
exports.mockPostPartnerDeveloperFailure = mockPostPartnerDeveloperFailure;
/**
 * No description
 */
function fetchPostPasswordLogin({ body, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/password/login/`, {
        method: "post",
        version: "edge",
        body,
    });
}
exports.fetchPostPasswordLogin = fetchPostPasswordLogin;
function mockPostPasswordLoginSuccess(data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/password/login/`, "post", 200, data, options);
}
exports.mockPostPasswordLoginSuccess = mockPostPasswordLoginSuccess;
function mockPostPasswordLoginFailure(options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/password/login/`, "post", 400, failureResponse, options);
}
exports.mockPostPasswordLoginFailure = mockPostPasswordLoginFailure;
/**
 * No description
 */
function fetchPostPasswordReset({ body, }) {
    return (0, lendingAPI_1.fetchLendingAPI)(`/password/reset/`, {
        method: "post",
        version: "edge",
        body,
    });
}
exports.fetchPostPasswordReset = fetchPostPasswordReset;
function mockPostPasswordResetSuccess(data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/password/reset/`, "post", 204, data, options);
}
exports.mockPostPasswordResetSuccess = mockPostPasswordResetSuccess;
function mockPostPasswordResetFailure(options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/password/reset/`, "post", 400, failureResponse, options);
}
exports.mockPostPasswordResetFailure = mockPostPasswordResetFailure;
/**
 * No description
 */
function fetchPostPasswordResetSetPassword({ body, }) {
    return (0, lendingAPI_1.fetchLendingAPI)(`/password/reset/set-password/`, {
        method: "post",
        version: "edge",
        body,
    });
}
exports.fetchPostPasswordResetSetPassword = fetchPostPasswordResetSetPassword;
function mockPostPasswordResetSetPasswordSuccess(data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/password/reset/set-password/`, "post", 204, data, options);
}
exports.mockPostPasswordResetSetPasswordSuccess = mockPostPasswordResetSetPasswordSuccess;
function mockPostPasswordResetSetPasswordFailure(options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/password/reset/set-password/`, "post", 400, failureResponse, options);
}
exports.mockPostPasswordResetSetPasswordFailure = mockPostPasswordResetSetPasswordFailure;
/**
 * No description
 */
function fetchPostPasswordResetVerify({ body, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/password/reset/verify/`, {
        method: "post",
        version: "edge",
        body,
    });
}
exports.fetchPostPasswordResetVerify = fetchPostPasswordResetVerify;
function mockPostPasswordResetVerifySuccess(data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/password/reset/verify/`, "post", 200, data, options);
}
exports.mockPostPasswordResetVerifySuccess = mockPostPasswordResetVerifySuccess;
function mockPostPasswordResetVerifyFailure(options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/password/reset/verify/`, "post", 400, failureResponse, options);
}
exports.mockPostPasswordResetVerifyFailure = mockPostPasswordResetVerifyFailure;
/**
 * No description
 */
function fetchPostPasswordlessEmail({ body, }) {
    return (0, lendingAPI_1.fetchLendingAPI)(`/passwordless/email/`, {
        method: "post",
        version: "edge",
        body,
    });
}
exports.fetchPostPasswordlessEmail = fetchPostPasswordlessEmail;
function mockPostPasswordlessEmailSuccess(data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/passwordless/email/`, "post", 204, data, options);
}
exports.mockPostPasswordlessEmailSuccess = mockPostPasswordlessEmailSuccess;
function mockPostPasswordlessEmailFailure(options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/passwordless/email/`, "post", 400, failureResponse, options);
}
exports.mockPostPasswordlessEmailFailure = mockPostPasswordlessEmailFailure;
/**
 * No description
 */
function fetchPostPasswordlessEmailLogin({ body, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/passwordless/email/login/`, {
        method: "post",
        version: "edge",
        body,
    });
}
exports.fetchPostPasswordlessEmailLogin = fetchPostPasswordlessEmailLogin;
function mockPostPasswordlessEmailLoginSuccess(data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/passwordless/email/login/`, "post", 200, data, options);
}
exports.mockPostPasswordlessEmailLoginSuccess = mockPostPasswordlessEmailLoginSuccess;
function mockPostPasswordlessEmailLoginFailure(options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/passwordless/email/login/`, "post", 400, failureResponse, options);
}
exports.mockPostPasswordlessEmailLoginFailure = mockPostPasswordlessEmailLoginFailure;
/**
 * No description
 */
function fetchPostPayLink({ body }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/pay_link/`, {
        method: "post",
        version: "edge",
        body,
    });
}
exports.fetchPostPayLink = fetchPostPayLink;
function mockPostPayLinkSuccess(data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/pay_link/`, "post", 201, data, options);
}
exports.mockPostPayLinkSuccess = mockPostPayLinkSuccess;
function mockPostPayLinkFailure(options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/pay_link/`, "post", 400, failureResponse, options);
}
exports.mockPostPayLinkFailure = mockPostPayLinkFailure;
/**
 * No description
 */
function fetchPutPayLink({ body }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/pay_link/`, {
        method: "put",
        version: "edge",
        body,
    });
}
exports.fetchPutPayLink = fetchPutPayLink;
function mockPutPayLinkSuccess(data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/pay_link/`, "put", 202, data, options);
}
exports.mockPutPayLinkSuccess = mockPutPayLinkSuccess;
function mockPutPayLinkFailure(options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/pay_link/`, "put", 400, failureResponse, options);
}
exports.mockPutPayLinkFailure = mockPutPayLinkFailure;
/**
 * Redirect to a pay link page corresponding to a external link.
 */
function fetchGetPayLinkGo({ query, }) {
    return (0, lendingAPI_1.fetchLendingAPI)(`/pay_link/go/`, {
        method: "get",
        version: "edge",
        query,
    });
}
exports.fetchGetPayLinkGo = fetchGetPayLinkGo;
function mockGetPayLinkGoFailure(options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/pay_link/go/`, "get", 400, failureResponse, options);
}
exports.mockGetPayLinkGoFailure = mockGetPayLinkGoFailure;
/**
 * No description
 */
function fetchGetPayLinkByPayLinkId({ payLinkId, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/pay_link/${payLinkId}/`, {
        method: "get",
        version: "edge",
    });
}
exports.fetchGetPayLinkByPayLinkId = fetchGetPayLinkByPayLinkId;
function mockGetPayLinkByPayLinkIdSuccess(payLinkId, data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/pay_link/${payLinkId}/`, "get", 200, data, options);
}
exports.mockGetPayLinkByPayLinkIdSuccess = mockGetPayLinkByPayLinkIdSuccess;
function mockGetPayLinkByPayLinkIdFailure(payLinkId, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/pay_link/${payLinkId}/`, "get", 400, failureResponse, options);
}
exports.mockGetPayLinkByPayLinkIdFailure = mockGetPayLinkByPayLinkIdFailure;
/**
 * No description
 */
function fetchGetPayLink({}) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/pay_link/`, {
        method: "get",
        version: "edge",
    });
}
exports.fetchGetPayLink = fetchGetPayLink;
function mockGetPayLinkSuccess(data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/pay_link/`, "get", 200, data, options);
}
exports.mockGetPayLinkSuccess = mockGetPayLinkSuccess;
function mockGetPayLinkFailure(options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/pay_link/`, "get", 400, failureResponse, options);
}
exports.mockGetPayLinkFailure = mockGetPayLinkFailure;
/**
 * TBD
 */
function fetchPostPayLinkApplication({ payLinkId, body, }) {
    return (0, lendingAPI_1.fetchLendingAPI)(`/pay_link/${payLinkId}/application/`, {
        method: "post",
        version: "edge",
        body,
    });
}
exports.fetchPostPayLinkApplication = fetchPostPayLinkApplication;
function mockPostPayLinkApplicationSuccess(payLinkId, data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/pay_link/${payLinkId}/application/`, "post", 201, data, options);
}
exports.mockPostPayLinkApplicationSuccess = mockPostPayLinkApplicationSuccess;
function mockPostPayLinkApplicationFailure(payLinkId, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/pay_link/${payLinkId}/application/`, "post", 400, failureResponse, options);
}
exports.mockPostPayLinkApplicationFailure = mockPostPayLinkApplicationFailure;
/**
 * TBD
 */
function fetchPostPledgeCall({ stateKey, body, }) {
    return (0, lendingAPI_1.fetchLendingAPI)(`/pledge_call/${stateKey}/`, {
        method: "post",
        version: "edge",
        body,
    });
}
exports.fetchPostPledgeCall = fetchPostPledgeCall;
function mockPostPledgeCallSuccess(stateKey, data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/pledge_call/${stateKey}/`, "post", 201, data, options);
}
exports.mockPostPledgeCallSuccess = mockPostPledgeCallSuccess;
function mockPostPledgeCallFailure(stateKey, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/pledge_call/${stateKey}/`, "post", 400, failureResponse, options);
}
exports.mockPostPledgeCallFailure = mockPostPledgeCallFailure;
/**
 * No description
 */
function fetchGetProductOffersByRestrictedExternalDataSyncsAuthorisation({ stateKey, restrictedExternalDataSyncsAuthorisation, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/product_offers/${stateKey}/${restrictedExternalDataSyncsAuthorisation}/`, {
        method: "get",
        version: "edge",
    });
}
exports.fetchGetProductOffersByRestrictedExternalDataSyncsAuthorisation = fetchGetProductOffersByRestrictedExternalDataSyncsAuthorisation;
function mockGetProductOffersByRestrictedExternalDataSyncsAuthorisationSuccess(stateKey, restrictedExternalDataSyncsAuthorisation, data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/product_offers/${stateKey}/${restrictedExternalDataSyncsAuthorisation}/`, "get", 200, data, options);
}
exports.mockGetProductOffersByRestrictedExternalDataSyncsAuthorisationSuccess = mockGetProductOffersByRestrictedExternalDataSyncsAuthorisationSuccess;
function mockGetProductOffersByRestrictedExternalDataSyncsAuthorisationFailure(stateKey, restrictedExternalDataSyncsAuthorisation, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/product_offers/${stateKey}/${restrictedExternalDataSyncsAuthorisation}/`, "get", 400, failureResponse, options);
}
exports.mockGetProductOffersByRestrictedExternalDataSyncsAuthorisationFailure = mockGetProductOffersByRestrictedExternalDataSyncsAuthorisationFailure;
/**
 * No description
 */
function fetchGetProductOffers({ stateKey }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/product_offers/${stateKey}/`, {
        method: "get",
        version: "edge",
    });
}
exports.fetchGetProductOffers = fetchGetProductOffers;
function mockGetProductOffersSuccess(stateKey, data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/product_offers/${stateKey}/`, "get", 200, data, options);
}
exports.mockGetProductOffersSuccess = mockGetProductOffersSuccess;
function mockGetProductOffersFailure(stateKey, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/product_offers/${stateKey}/`, "get", 400, failureResponse, options);
}
exports.mockGetProductOffersFailure = mockGetProductOffersFailure;
/**
 * Read access to user info
 */
function fetchGetProfile({}) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/profile/`, {
        method: "get",
        version: "edge",
    });
}
exports.fetchGetProfile = fetchGetProfile;
function mockGetProfileSuccess(data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/profile/`, "get", 200, data, options);
}
exports.mockGetProfileSuccess = mockGetProfileSuccess;
function mockGetProfileFailure(options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/profile/`, "get", 400, failureResponse, options);
}
exports.mockGetProfileFailure = mockGetProfileFailure;
/**
 * No description
 */
function fetchPostRejectOfferReasons({ stateKey, body, }) {
    return (0, lendingAPI_1.fetchLendingAPI)(`/reject_offer_reasons/${stateKey}/`, {
        method: "post",
        version: "edge",
        body,
    });
}
exports.fetchPostRejectOfferReasons = fetchPostRejectOfferReasons;
function mockPostRejectOfferReasonsSuccess(stateKey, data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/reject_offer_reasons/${stateKey}/`, "post", 201, data, options);
}
exports.mockPostRejectOfferReasonsSuccess = mockPostRejectOfferReasonsSuccess;
function mockPostRejectOfferReasonsFailure(stateKey, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/reject_offer_reasons/${stateKey}/`, "post", 400, failureResponse, options);
}
exports.mockPostRejectOfferReasonsFailure = mockPostRejectOfferReasonsFailure;
/**
 * Create an intent to pay.
 */
function fetchPostRepaymentPaymentIntent({ stateKey, body, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/repayment/${stateKey}/payment_intent/`, {
        method: "post",
        version: "edge",
        body,
    });
}
exports.fetchPostRepaymentPaymentIntent = fetchPostRepaymentPaymentIntent;
function mockPostRepaymentPaymentIntentSuccess(stateKey, data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/repayment/${stateKey}/payment_intent/`, "post", 201, data, options);
}
exports.mockPostRepaymentPaymentIntentSuccess = mockPostRepaymentPaymentIntentSuccess;
function mockPostRepaymentPaymentIntentFailure(stateKey, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/repayment/${stateKey}/payment_intent/`, "post", 400, failureResponse, options);
}
exports.mockPostRepaymentPaymentIntentFailure = mockPostRepaymentPaymentIntentFailure;
/**
 * Post the requested amount by customer coming to us through automated lending branch, without using Application model.
 */
function fetchPostRequestedAmount({ stateKey, body, }) {
    return (0, lendingAPI_1.fetchLendingAPI)(`/requested_amount/${stateKey}/`, {
        method: "post",
        version: "edge",
        body,
    });
}
exports.fetchPostRequestedAmount = fetchPostRequestedAmount;
function mockPostRequestedAmountSuccess(stateKey, data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/requested_amount/${stateKey}/`, "post", 201, data, options);
}
exports.mockPostRequestedAmountSuccess = mockPostRequestedAmountSuccess;
function mockPostRequestedAmountFailure(stateKey, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/requested_amount/${stateKey}/`, "post", 400, failureResponse, options);
}
exports.mockPostRequestedAmountFailure = mockPostRequestedAmountFailure;
/**
 * Get user Recovery Loan Scheme eligibility self assessment data
 */
function fetchGetRlsEligibilitySelfAssessment({ stateKey, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/rls_eligibility_self_assessment/${stateKey}/`, {
        method: "get",
        version: "edge",
    });
}
exports.fetchGetRlsEligibilitySelfAssessment = fetchGetRlsEligibilitySelfAssessment;
function mockGetRlsEligibilitySelfAssessmentSuccess(stateKey, data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/rls_eligibility_self_assessment/${stateKey}/`, "get", 200, data, options);
}
exports.mockGetRlsEligibilitySelfAssessmentSuccess = mockGetRlsEligibilitySelfAssessmentSuccess;
function mockGetRlsEligibilitySelfAssessmentFailure(stateKey, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/rls_eligibility_self_assessment/${stateKey}/`, "get", 400, failureResponse, options);
}
exports.mockGetRlsEligibilitySelfAssessmentFailure = mockGetRlsEligibilitySelfAssessmentFailure;
/**
 * Update user Recovery Loan Scheme eligibility self assessment
 */
function fetchPutRlsEligibilitySelfAssessment({ stateKey, body, }) {
    return (0, lendingAPI_1.fetchLendingAPI)(`/rls_eligibility_self_assessment/${stateKey}/`, {
        method: "put",
        version: "edge",
        body,
    });
}
exports.fetchPutRlsEligibilitySelfAssessment = fetchPutRlsEligibilitySelfAssessment;
function mockPutRlsEligibilitySelfAssessmentSuccess(stateKey, data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/rls_eligibility_self_assessment/${stateKey}/`, "put", 202, data, options);
}
exports.mockPutRlsEligibilitySelfAssessmentSuccess = mockPutRlsEligibilitySelfAssessmentSuccess;
function mockPutRlsEligibilitySelfAssessmentFailure(stateKey, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/rls_eligibility_self_assessment/${stateKey}/`, "put", 400, failureResponse, options);
}
exports.mockPutRlsEligibilitySelfAssessmentFailure = mockPutRlsEligibilitySelfAssessmentFailure;
/**
 * No description
 */
function fetchGetSellerHandle({ sellerHandle, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/seller/handle/${sellerHandle}/`, {
        method: "get",
        version: "edge",
    });
}
exports.fetchGetSellerHandle = fetchGetSellerHandle;
function mockGetSellerHandleSuccess(sellerHandle, data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/seller/handle/${sellerHandle}/`, "get", 200, data, options);
}
exports.mockGetSellerHandleSuccess = mockGetSellerHandleSuccess;
function mockGetSellerHandleFailure(sellerHandle, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/seller/handle/${sellerHandle}/`, "get", 400, failureResponse, options);
}
exports.mockGetSellerHandleFailure = mockGetSellerHandleFailure;
/**
 * No description
 */
function fetchGetSellerHandleAvailability({ sellerHandle, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/seller/handle/${sellerHandle}/availability/`, {
        method: "get",
        version: "edge",
    });
}
exports.fetchGetSellerHandleAvailability = fetchGetSellerHandleAvailability;
function mockGetSellerHandleAvailabilitySuccess(sellerHandle, data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/seller/handle/${sellerHandle}/availability/`, "get", 200, data, options);
}
exports.mockGetSellerHandleAvailabilitySuccess = mockGetSellerHandleAvailabilitySuccess;
function mockGetSellerHandleAvailabilityFailure(sellerHandle, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/seller/handle/${sellerHandle}/availability/`, "get", 400, failureResponse, options);
}
exports.mockGetSellerHandleAvailabilityFailure = mockGetSellerHandleAvailabilityFailure;
/**
 * No description
 */
function fetchGetSeller({ stateKey }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/seller/${stateKey}/`, {
        method: "get",
        version: "edge",
    });
}
exports.fetchGetSeller = fetchGetSeller;
function mockGetSellerSuccess(stateKey, data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/seller/${stateKey}/`, "get", 200, data, options);
}
exports.mockGetSellerSuccess = mockGetSellerSuccess;
function mockGetSellerFailure(stateKey, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/seller/${stateKey}/`, "get", 400, failureResponse, options);
}
exports.mockGetSellerFailure = mockGetSellerFailure;
/**
 * No description
 */
function fetchPostSeller({ stateKey, body, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/seller/${stateKey}/`, {
        method: "post",
        version: "edge",
        body,
    });
}
exports.fetchPostSeller = fetchPostSeller;
function mockPostSellerSuccess(stateKey, data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/seller/${stateKey}/`, "post", 201, data, options);
}
exports.mockPostSellerSuccess = mockPostSellerSuccess;
function mockPostSellerFailure(stateKey, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/seller/${stateKey}/`, "post", 400, failureResponse, options);
}
exports.mockPostSellerFailure = mockPostSellerFailure;
/**
 * No description
 */
function fetchPostSellerHandle({ stateKey, body, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/seller/${stateKey}/handle/`, {
        method: "post",
        version: "edge",
        body,
    });
}
exports.fetchPostSellerHandle = fetchPostSellerHandle;
function mockPostSellerHandleSuccess(stateKey, data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/seller/${stateKey}/handle/`, "post", 201, data, options);
}
exports.mockPostSellerHandleSuccess = mockPostSellerHandleSuccess;
function mockPostSellerHandleFailure(stateKey, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/seller/${stateKey}/handle/`, "post", 400, failureResponse, options);
}
exports.mockPostSellerHandleFailure = mockPostSellerHandleFailure;
/**
 * No description
 */
function fetchGetSellerPricing({ stateKey }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/seller/${stateKey}/pricing/`, {
        method: "get",
        version: "edge",
    });
}
exports.fetchGetSellerPricing = fetchGetSellerPricing;
function mockGetSellerPricingSuccess(stateKey, data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/seller/${stateKey}/pricing/`, "get", 200, data, options);
}
exports.mockGetSellerPricingSuccess = mockGetSellerPricingSuccess;
function mockGetSellerPricingFailure(stateKey, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/seller/${stateKey}/pricing/`, "get", 400, failureResponse, options);
}
exports.mockGetSellerPricingFailure = mockGetSellerPricingFailure;
/**
 * No description
 */
function fetchPutSellerPricing({ stateKey, body, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/seller/${stateKey}/pricing/`, {
        method: "put",
        version: "edge",
        body,
    });
}
exports.fetchPutSellerPricing = fetchPutSellerPricing;
function mockPutSellerPricingSuccess(stateKey, data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/seller/${stateKey}/pricing/`, "put", 202, data, options);
}
exports.mockPutSellerPricingSuccess = mockPutSellerPricingSuccess;
function mockPutSellerPricingFailure(stateKey, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/seller/${stateKey}/pricing/`, "put", 400, failureResponse, options);
}
exports.mockPutSellerPricingFailure = mockPutSellerPricingFailure;
/**
 * No description
 */
function fetchGetSellerAgreementDocument({ stateKey, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/seller_agreement_document/${stateKey}/`, {
        method: "get",
        version: "edge",
    });
}
exports.fetchGetSellerAgreementDocument = fetchGetSellerAgreementDocument;
function mockGetSellerAgreementDocumentSuccess(stateKey, data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/seller_agreement_document/${stateKey}/`, "get", 200, data, options);
}
exports.mockGetSellerAgreementDocumentSuccess = mockGetSellerAgreementDocumentSuccess;
function mockGetSellerAgreementDocumentFailure(stateKey, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/seller_agreement_document/${stateKey}/`, "get", 400, failureResponse, options);
}
exports.mockGetSellerAgreementDocumentFailure = mockGetSellerAgreementDocumentFailure;
/**
 * No description
 */
function fetchGetSellerAgreementDocumentDownload({ stateKey, documentId, query, }) {
    return (0, lendingAPI_1.fetchLendingAPI)(`/seller_agreement_document/${stateKey}/download/${documentId}/`, {
        method: "get",
        version: "edge",
        query,
    });
}
exports.fetchGetSellerAgreementDocumentDownload = fetchGetSellerAgreementDocumentDownload;
function mockGetSellerAgreementDocumentDownloadSuccess(stateKey, documentId, data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/seller_agreement_document/${stateKey}/download/${documentId}/`, "get", 200, data, options);
}
exports.mockGetSellerAgreementDocumentDownloadSuccess = mockGetSellerAgreementDocumentDownloadSuccess;
function mockGetSellerAgreementDocumentDownloadFailure(stateKey, documentId, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/seller_agreement_document/${stateKey}/download/${documentId}/`, "get", 400, failureResponse, options);
}
exports.mockGetSellerAgreementDocumentDownloadFailure = mockGetSellerAgreementDocumentDownloadFailure;
/**
 * No description
 */
function fetchPutSellerAgreementDocumentSign({ stateKey, documentId, body, }) {
    return (0, lendingAPI_1.fetchLendingAPI)(`/seller_agreement_document/${stateKey}/sign/${documentId}/`, {
        method: "put",
        version: "edge",
        body,
    });
}
exports.fetchPutSellerAgreementDocumentSign = fetchPutSellerAgreementDocumentSign;
function mockPutSellerAgreementDocumentSignSuccess(stateKey, documentId, data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/seller_agreement_document/${stateKey}/sign/${documentId}/`, "put", 202, data, options);
}
exports.mockPutSellerAgreementDocumentSignSuccess = mockPutSellerAgreementDocumentSignSuccess;
function mockPutSellerAgreementDocumentSignFailure(stateKey, documentId, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/seller_agreement_document/${stateKey}/sign/${documentId}/`, "put", 400, failureResponse, options);
}
exports.mockPutSellerAgreementDocumentSignFailure = mockPutSellerAgreementDocumentSignFailure;
/**
 * No description
 */
function fetchGetSellerOnboardingRequirements({ stateKey, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/seller_onboarding_requirements/${stateKey}/`, {
        method: "get",
        version: "edge",
    });
}
exports.fetchGetSellerOnboardingRequirements = fetchGetSellerOnboardingRequirements;
function mockGetSellerOnboardingRequirementsSuccess(stateKey, data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/seller_onboarding_requirements/${stateKey}/`, "get", 200, data, options);
}
exports.mockGetSellerOnboardingRequirementsSuccess = mockGetSellerOnboardingRequirementsSuccess;
function mockGetSellerOnboardingRequirementsFailure(stateKey, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/seller_onboarding_requirements/${stateKey}/`, "get", 400, failureResponse, options);
}
exports.mockGetSellerOnboardingRequirementsFailure = mockGetSellerOnboardingRequirementsFailure;
/**
 * No description
 */
function fetchPostSingleImmediatePayment({ body, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/single_immediate_payment/`, {
        method: "post",
        version: "edge",
        body,
    });
}
exports.fetchPostSingleImmediatePayment = fetchPostSingleImmediatePayment;
function mockPostSingleImmediatePaymentSuccess(data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/single_immediate_payment/`, "post", 201, data, options);
}
exports.mockPostSingleImmediatePaymentSuccess = mockPostSingleImmediatePaymentSuccess;
function mockPostSingleImmediatePaymentFailure(options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/single_immediate_payment/`, "post", 400, failureResponse, options);
}
exports.mockPostSingleImmediatePaymentFailure = mockPostSingleImmediatePaymentFailure;
/**
 * Endpoint for processing status updates for TrueLayer Single Immediate Payments
 */
function fetchPostSingleImmediatePaymentProcessWebhook({ body, }) {
    return (0, lendingAPI_1.fetchLendingAPI)(`/single_immediate_payment/process_webhook/`, {
        method: "post",
        version: "edge",
        body,
    });
}
exports.fetchPostSingleImmediatePaymentProcessWebhook = fetchPostSingleImmediatePaymentProcessWebhook;
function mockPostSingleImmediatePaymentProcessWebhookSuccess(data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/single_immediate_payment/process_webhook/`, "post", 201, data, options);
}
exports.mockPostSingleImmediatePaymentProcessWebhookSuccess = mockPostSingleImmediatePaymentProcessWebhookSuccess;
function mockPostSingleImmediatePaymentProcessWebhookFailure(options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/single_immediate_payment/process_webhook/`, "post", 400, failureResponse, options);
}
exports.mockPostSingleImmediatePaymentProcessWebhookFailure = mockPostSingleImmediatePaymentProcessWebhookFailure;
/**
 * No description
 */
function fetchGetSingleImmediatePayment({ paymentId, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/single_immediate_payment/${paymentId}/`, {
        method: "get",
        version: "edge",
    });
}
exports.fetchGetSingleImmediatePayment = fetchGetSingleImmediatePayment;
function mockGetSingleImmediatePaymentSuccess(paymentId, data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/single_immediate_payment/${paymentId}/`, "get", 200, data, options);
}
exports.mockGetSingleImmediatePaymentSuccess = mockGetSingleImmediatePaymentSuccess;
function mockGetSingleImmediatePaymentFailure(paymentId, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/single_immediate_payment/${paymentId}/`, "get", 400, failureResponse, options);
}
exports.mockGetSingleImmediatePaymentFailure = mockGetSingleImmediatePaymentFailure;
/**
 * Endpoint for sending a Single Immediate Payment confirmation email
 */
function fetchPostSingleImmediatePaymentSendConfirmationEmail({ paymentId, body, }) {
    return (0, lendingAPI_1.fetchLendingAPI)(`/single_immediate_payment/${paymentId}/send_confirmation_email/`, {
        method: "post",
        version: "edge",
        body,
    });
}
exports.fetchPostSingleImmediatePaymentSendConfirmationEmail = fetchPostSingleImmediatePaymentSendConfirmationEmail;
function mockPostSingleImmediatePaymentSendConfirmationEmailSuccess(paymentId, data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/single_immediate_payment/${paymentId}/send_confirmation_email/`, "post", 201, data, options);
}
exports.mockPostSingleImmediatePaymentSendConfirmationEmailSuccess = mockPostSingleImmediatePaymentSendConfirmationEmailSuccess;
function mockPostSingleImmediatePaymentSendConfirmationEmailFailure(paymentId, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/single_immediate_payment/${paymentId}/send_confirmation_email/`, "post", 400, failureResponse, options);
}
exports.mockPostSingleImmediatePaymentSendConfirmationEmailFailure = mockPostSingleImmediatePaymentSendConfirmationEmailFailure;
/**
 * The POST request should be used to create an iwoca account for the customer. It&#x27;s always the first endpoint and method you should call when submitting a new customer. We&#x27;ll return a state_key used to identify the customer in all future requests. Almost all fields in the State are optional since you can submit a partial application initially, then add or update data over time (through the PUT method). Your iwoca contact will be able to give you details on which fields are recommended to help us make a lending decision.
 */
function fetchPostState({ body }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/state/`, {
        method: "post",
        version: "edge",
        body,
    });
}
exports.fetchPostState = fetchPostState;
function mockPostStateSuccess(data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/state/`, "post", 201, data, options);
}
exports.mockPostStateSuccess = mockPostStateSuccess;
function mockPostStateFailure(options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/state/`, "post", 400, failureResponse, options);
}
exports.mockPostStateFailure = mockPostStateFailure;
/**
 * No description
 */
function fetchGetStateByStateKey({ stateKey }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/state/${stateKey}/`, {
        method: "get",
        version: "edge",
    });
}
exports.fetchGetStateByStateKey = fetchGetStateByStateKey;
function mockGetStateByStateKeySuccess(stateKey, data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/state/${stateKey}/`, "get", 200, data, options);
}
exports.mockGetStateByStateKeySuccess = mockGetStateByStateKeySuccess;
function mockGetStateByStateKeyFailure(stateKey, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/state/${stateKey}/`, "get", 400, failureResponse, options);
}
exports.mockGetStateByStateKeyFailure = mockGetStateByStateKeyFailure;
/**
 * No description
 */
function fetchGetState({}) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/state/`, {
        method: "get",
        version: "edge",
    });
}
exports.fetchGetState = fetchGetState;
function mockGetStateSuccess(data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/state/`, "get", 200, data, options);
}
exports.mockGetStateSuccess = mockGetStateSuccess;
function mockGetStateFailure(options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/state/`, "get", 400, failureResponse, options);
}
exports.mockGetStateFailure = mockGetStateFailure;
/**
 * The PUT request should be used to add or update data for a customer. Note that the entire State should be submitted each time you use this endpoint, even if you are just updating a few fields.
 */
function fetchPutState({ stateKey, body, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/state/${stateKey}/`, {
        method: "put",
        version: "edge",
        body,
    });
}
exports.fetchPutState = fetchPutState;
function mockPutStateSuccess(stateKey, data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/state/${stateKey}/`, "put", 202, data, options);
}
exports.mockPutStateSuccess = mockPutStateSuccess;
function mockPutStateFailure(stateKey, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/state/${stateKey}/`, "put", 400, failureResponse, options);
}
exports.mockPutStateFailure = mockPutStateFailure;
/**
 * No description
 */
function fetchGetStatements({ stateKey, query, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/statements/${stateKey}/`, {
        method: "get",
        version: "edge",
        query,
    });
}
exports.fetchGetStatements = fetchGetStatements;
function mockGetStatementsSuccess(stateKey, data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/statements/${stateKey}/`, "get", 200, data, options);
}
exports.mockGetStatementsSuccess = mockGetStatementsSuccess;
function mockGetStatementsFailure(stateKey, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/statements/${stateKey}/`, "get", 400, failureResponse, options);
}
exports.mockGetStatementsFailure = mockGetStatementsFailure;
/**
 * Create a ThreatMetrix event
 */
function fetchPostThreatmetrixEvent({ stateKey, body, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/threatmetrix/${stateKey}/event/`, {
        method: "post",
        version: "edge",
        body,
    });
}
exports.fetchPostThreatmetrixEvent = fetchPostThreatmetrixEvent;
function mockPostThreatmetrixEventSuccess(stateKey, data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/threatmetrix/${stateKey}/event/`, "post", 201, data, options);
}
exports.mockPostThreatmetrixEventSuccess = mockPostThreatmetrixEventSuccess;
function mockPostThreatmetrixEventFailure(stateKey, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/threatmetrix/${stateKey}/event/`, "post", 400, failureResponse, options);
}
exports.mockPostThreatmetrixEventFailure = mockPostThreatmetrixEventFailure;
/**
 * Update a ThreatMetrix event.
 */
function fetchPutThreatmetrixEvent({ stateKey, tmSessionId, body, }) {
    return (0, lendingAPI_1.fetchLendingAPI)(`/threatmetrix/${stateKey}/event/${tmSessionId}/`, {
        method: "put",
        version: "edge",
        body,
    });
}
exports.fetchPutThreatmetrixEvent = fetchPutThreatmetrixEvent;
function mockPutThreatmetrixEventSuccess(stateKey, tmSessionId, data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/threatmetrix/${stateKey}/event/${tmSessionId}/`, "put", 204, data, options);
}
exports.mockPutThreatmetrixEventSuccess = mockPutThreatmetrixEventSuccess;
function mockPutThreatmetrixEventFailure(stateKey, tmSessionId, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/threatmetrix/${stateKey}/event/${tmSessionId}/`, "put", 400, failureResponse, options);
}
exports.mockPutThreatmetrixEventFailure = mockPutThreatmetrixEventFailure;
/**
 * Return a list of Xero accounts.
 */
function fetchGetXeroAccounts({ reason, stateKey, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/xero/accounts/${reason}/${stateKey}/`, {
        method: "get",
        version: "edge",
    });
}
exports.fetchGetXeroAccounts = fetchGetXeroAccounts;
function mockGetXeroAccountsSuccess(reason, stateKey, data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/xero/accounts/${reason}/${stateKey}/`, "get", 200, data, options);
}
exports.mockGetXeroAccountsSuccess = mockGetXeroAccountsSuccess;
function mockGetXeroAccountsFailure(reason, stateKey, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/xero/accounts/${reason}/${stateKey}/`, "get", 400, failureResponse, options);
}
exports.mockGetXeroAccountsFailure = mockGetXeroAccountsFailure;
/**
 * Callback url after successful Xero authorisation.
 */
function fetchGetXeroCallback({ reason }) {
    return (0, lendingAPI_1.fetchLendingAPI)(`/xero/callback/${reason}/`, {
        method: "get",
        version: "edge",
    });
}
exports.fetchGetXeroCallback = fetchGetXeroCallback;
function mockGetXeroCallbackFailure(reason, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/xero/callback/${reason}/`, "get", 400, failureResponse, options);
}
exports.mockGetXeroCallbackFailure = mockGetXeroCallbackFailure;
/**
 * Exchange the authorisation code for an access token.
 */
function fetchPostXeroConnect({ reason, stateKey, body, }) {
    return (0, lendingAPI_1.fetchLendingAPI)(`/xero/connect/${reason}/${stateKey}/`, {
        method: "post",
        version: "edge",
        body,
    });
}
exports.fetchPostXeroConnect = fetchPostXeroConnect;
function mockPostXeroConnectSuccess(reason, stateKey, data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/xero/connect/${reason}/${stateKey}/`, "post", 204, data, options);
}
exports.mockPostXeroConnectSuccess = mockPostXeroConnectSuccess;
function mockPostXeroConnectFailure(reason, stateKey, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/xero/connect/${reason}/${stateKey}/`, "post", 400, failureResponse, options);
}
exports.mockPostXeroConnectFailure = mockPostXeroConnectFailure;
/**
 * Returns a list of tenants and the related organisation iwoca is authorized to access.
 */
function fetchGetXeroConnections({ reason, stateKey, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/xero/connections/${reason}/${stateKey}/`, {
        method: "get",
        version: "edge",
    });
}
exports.fetchGetXeroConnections = fetchGetXeroConnections;
function mockGetXeroConnectionsSuccess(reason, stateKey, data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/xero/connections/${reason}/${stateKey}/`, "get", 200, data, options);
}
exports.mockGetXeroConnectionsSuccess = mockGetXeroConnectionsSuccess;
function mockGetXeroConnectionsFailure(reason, stateKey, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/xero/connections/${reason}/${stateKey}/`, "get", 400, failureResponse, options);
}
exports.mockGetXeroConnectionsFailure = mockGetXeroConnectionsFailure;
/**
 * No description
 */
function fetchGetXeroIwocapaySellerAccount({ stateKey, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/xero/iwocapay_seller/account/${stateKey}/`, {
        method: "get",
        version: "edge",
    });
}
exports.fetchGetXeroIwocapaySellerAccount = fetchGetXeroIwocapaySellerAccount;
function mockGetXeroIwocapaySellerAccountSuccess(stateKey, data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/xero/iwocapay_seller/account/${stateKey}/`, "get", 200, data, options);
}
exports.mockGetXeroIwocapaySellerAccountSuccess = mockGetXeroIwocapaySellerAccountSuccess;
function mockGetXeroIwocapaySellerAccountFailure(stateKey, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/xero/iwocapay_seller/account/${stateKey}/`, "get", 400, failureResponse, options);
}
exports.mockGetXeroIwocapaySellerAccountFailure = mockGetXeroIwocapaySellerAccountFailure;
/**
 * No description
 */
function fetchPostXeroIwocapaySellerAccount({ stateKey, body, }) {
    return (0, lendingAPI_1.fetchLendingAPI)(`/xero/iwocapay_seller/account/${stateKey}/`, {
        method: "post",
        version: "edge",
        body,
    });
}
exports.fetchPostXeroIwocapaySellerAccount = fetchPostXeroIwocapaySellerAccount;
function mockPostXeroIwocapaySellerAccountSuccess(stateKey, data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/xero/iwocapay_seller/account/${stateKey}/`, "post", 204, data, options);
}
exports.mockPostXeroIwocapaySellerAccountSuccess = mockPostXeroIwocapaySellerAccountSuccess;
function mockPostXeroIwocapaySellerAccountFailure(stateKey, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/xero/iwocapay_seller/account/${stateKey}/`, "post", 400, failureResponse, options);
}
exports.mockPostXeroIwocapaySellerAccountFailure = mockPostXeroIwocapaySellerAccountFailure;
/**
 * No description
 */
function fetchPutXeroIwocapaySellerAccount({ stateKey, body, }) {
    return (0, lendingAPI_1.fetchLendingAPI)(`/xero/iwocapay_seller/account/${stateKey}/`, {
        method: "put",
        version: "edge",
        body,
    });
}
exports.fetchPutXeroIwocapaySellerAccount = fetchPutXeroIwocapaySellerAccount;
function mockPutXeroIwocapaySellerAccountSuccess(stateKey, data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/xero/iwocapay_seller/account/${stateKey}/`, "put", 204, data, options);
}
exports.mockPutXeroIwocapaySellerAccountSuccess = mockPutXeroIwocapaySellerAccountSuccess;
function mockPutXeroIwocapaySellerAccountFailure(stateKey, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/xero/iwocapay_seller/account/${stateKey}/`, "put", 400, failureResponse, options);
}
exports.mockPutXeroIwocapaySellerAccountFailure = mockPutXeroIwocapaySellerAccountFailure;
/**
 * Return a list of Xero branding themes.
 */
function fetchGetXeroIwocapaySellerBrandingThemes({ stateKey, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/xero/iwocapay_seller/branding_themes/${stateKey}/`, {
        method: "get",
        version: "edge",
    });
}
exports.fetchGetXeroIwocapaySellerBrandingThemes = fetchGetXeroIwocapaySellerBrandingThemes;
function mockGetXeroIwocapaySellerBrandingThemesSuccess(stateKey, data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/xero/iwocapay_seller/branding_themes/${stateKey}/`, "get", 200, data, options);
}
exports.mockGetXeroIwocapaySellerBrandingThemesSuccess = mockGetXeroIwocapaySellerBrandingThemesSuccess;
function mockGetXeroIwocapaySellerBrandingThemesFailure(stateKey, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/xero/iwocapay_seller/branding_themes/${stateKey}/`, "get", 400, failureResponse, options);
}
exports.mockGetXeroIwocapaySellerBrandingThemesFailure = mockGetXeroIwocapaySellerBrandingThemesFailure;
/**
 * Add iwocaPay as a new payment service to list of branding themes.
 */
function fetchPostXeroIwocapaySellerBrandingThemesPaymentServices({ stateKey, body, }) {
    return (0, lendingAPI_1.fetchLendingAPI)(`/xero/iwocapay_seller/branding_themes/${stateKey}/payment_services/`, {
        method: "post",
        version: "edge",
        body,
    });
}
exports.fetchPostXeroIwocapaySellerBrandingThemesPaymentServices = fetchPostXeroIwocapaySellerBrandingThemesPaymentServices;
function mockPostXeroIwocapaySellerBrandingThemesPaymentServicesSuccess(stateKey, data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/xero/iwocapay_seller/branding_themes/${stateKey}/payment_services/`, "post", 204, data, options);
}
exports.mockPostXeroIwocapaySellerBrandingThemesPaymentServicesSuccess = mockPostXeroIwocapaySellerBrandingThemesPaymentServicesSuccess;
function mockPostXeroIwocapaySellerBrandingThemesPaymentServicesFailure(stateKey, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/xero/iwocapay_seller/branding_themes/${stateKey}/payment_services/`, "post", 400, failureResponse, options);
}
exports.mockPostXeroIwocapaySellerBrandingThemesPaymentServicesFailure = mockPostXeroIwocapaySellerBrandingThemesPaymentServicesFailure;
/**
 * HTTP 302 redirect to Xero for authorization.
 */
function fetchGetXeroLogin({ reason, stateKey, }) {
    return (0, lendingAPI_1.fetchLendingAPI)(`/xero/login/${reason}/${stateKey}/`, {
        method: "get",
        version: "edge",
    });
}
exports.fetchGetXeroLogin = fetchGetXeroLogin;
function mockGetXeroLoginFailure(reason, stateKey, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/xero/login/${reason}/${stateKey}/`, "get", 400, failureResponse, options);
}
exports.mockGetXeroLoginFailure = mockGetXeroLoginFailure;
/**
 * Get the authorization url to redirect user to Xero.
 */
function fetchPostXeroLogin({ reason, stateKey, body, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/xero/login/${reason}/${stateKey}/`, {
        method: "post",
        version: "edge",
        body,
    });
}
exports.fetchPostXeroLogin = fetchPostXeroLogin;
function mockPostXeroLoginSuccess(reason, stateKey, data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/xero/login/${reason}/${stateKey}/`, "post", 200, data, options);
}
exports.mockPostXeroLoginSuccess = mockPostXeroLoginSuccess;
function mockPostXeroLoginFailure(reason, stateKey, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/xero/login/${reason}/${stateKey}/`, "post", 400, failureResponse, options);
}
exports.mockPostXeroLoginFailure = mockPostXeroLoginFailure;
/**
 * No description
 */
function fetchGetXeroOrganisationAccount({ stateKey, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/xero/organisation/account/${stateKey}/`, {
        method: "get",
        version: "edge",
    });
}
exports.fetchGetXeroOrganisationAccount = fetchGetXeroOrganisationAccount;
function mockGetXeroOrganisationAccountSuccess(stateKey, data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/xero/organisation/account/${stateKey}/`, "get", 200, data, options);
}
exports.mockGetXeroOrganisationAccountSuccess = mockGetXeroOrganisationAccountSuccess;
function mockGetXeroOrganisationAccountFailure(stateKey, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/xero/organisation/account/${stateKey}/`, "get", 400, failureResponse, options);
}
exports.mockGetXeroOrganisationAccountFailure = mockGetXeroOrganisationAccountFailure;
/**
 * No description
 */
function fetchPostXeroOrganisationAccount({ stateKey, body, }) {
    return (0, lendingAPI_1.fetchLendingAPI)(`/xero/organisation/account/${stateKey}/`, {
        method: "post",
        version: "edge",
        body,
    });
}
exports.fetchPostXeroOrganisationAccount = fetchPostXeroOrganisationAccount;
function mockPostXeroOrganisationAccountSuccess(stateKey, data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/xero/organisation/account/${stateKey}/`, "post", 204, data, options);
}
exports.mockPostXeroOrganisationAccountSuccess = mockPostXeroOrganisationAccountSuccess;
function mockPostXeroOrganisationAccountFailure(stateKey, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/xero/organisation/account/${stateKey}/`, "post", 400, failureResponse, options);
}
exports.mockPostXeroOrganisationAccountFailure = mockPostXeroOrganisationAccountFailure;
/**
 * No description
 */
function fetchPutXeroOrganisationAccount({ stateKey, body, }) {
    return (0, lendingAPI_1.fetchLendingAPI)(`/xero/organisation/account/${stateKey}/`, {
        method: "put",
        version: "edge",
        body,
    });
}
exports.fetchPutXeroOrganisationAccount = fetchPutXeroOrganisationAccount;
function mockPutXeroOrganisationAccountSuccess(stateKey, data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/xero/organisation/account/${stateKey}/`, "put", 204, data, options);
}
exports.mockPutXeroOrganisationAccountSuccess = mockPutXeroOrganisationAccountSuccess;
function mockPutXeroOrganisationAccountFailure(stateKey, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/xero/organisation/account/${stateKey}/`, "put", 400, failureResponse, options);
}
exports.mockPutXeroOrganisationAccountFailure = mockPutXeroOrganisationAccountFailure;
